{
  "filtra_per_data": "Filter by date",
  "tipologia_pulmino": "Vehicle type",
  "disposizione_posti": "Seat layout",
  "rinomina": "Rename",
  "sposta": "Move",
  "nuova_cartella": "New folder",
  "nome_cartella": "Folder name",
  "ordina": "Sort",
  "modificato": "Modified",
  "dimensione": "Size",
  "data_e_ora": "Date and time",
  "rilascia_per_caricare": "Drop to upload",
  "sicuro_sposta": "Move \"{{name}}\" here?",
  "sicuro_rimuovi_cartella": "Delete the folder and all its contents?",
  "documento_spostato_successo": "Document moved",
  "errore_spostamento": "Error while moving",
  "documento_rinominato_successo": "Document renamed",
  "errore_rinomina": "Error while renaming",
  "seat_cycle_hint": "Click to cycle: passenger → wheelchair → empty",
  "posto_autista": "Driver",
  "posto_passeggero": "Passenger",
  "posto_carrozzina": "Wheelchair",
  "posto_vuoto": "Empty",
  "modifica_tipologia": "Edit type",
  "nuova_tipologia": "New type",
  "nome_tipologia": "Type name",
  "nome_tipologia_placeholder": "e.g. Minibus 9 seats, Minibus 15 seats WC",
  "posti_totali": "Total seats (incl. driver)",
  "posti_passeggeri": "Passenger seats",
  "layout_posti": "Seat layout",
  "file": "Rows",
  "colonne": "Columns",
  "posto_autista_hint": "The top-left seat is always the driver",
  "salva_modifiche": "Save changes",
  "crea_tipologia": "Create type",
  "tipologie_pulmino": "Minibus Types",
  "nessuna_tipologia": "No type configured",
  "layout": "Layout",
  "sicuro_rimuovi_tipologia": "Delete the type \"{{name}}\"?",
  "salvataggio_riuscito": "Saved successfully",
  "errore_salvataggio": "Error while saving",
  "errore_aggiornamento": "Error while updating",
  "errore_caricamento": "Error while loading",
  "abilita": "Enable",
  "disabilita": "Disable",
  "mostra_credenziali": "Show credentials",
  "nascondi_credenziali": "Hide credentials",
  "nessun_documento": "No document",
  "rimuovi": "Remove",
  "nessun_evento": "No event",
  "nessun_turno": "No shift found for this month",
  "totale_mensile": "Monthly total",
  "mese_precedente": "Previous month",
  "mese_successivo": "Next month",
  "inizio_turno": "Shift start",
  "fine_turno": "Shift end",
  "totale_transato": "Total transacted:",
  "totale_viaggi": "Total trips:",
  "transato_gestore": "Transacted by manager",
  "viaggi_gestore": "Trips by manager",
  "transato_contratto": "Transacted by contract",
  "viaggi_contratto": "Trips by contract",
  "dettaglio_check": "Check detail",
  "dati_check": "Check data",
  "chilometri": "Kilometers",
  "ultimo_controllo_acqua": "Last water check",
  "ultimo_controllo_olio": "Last oil check",
  "sottomesso_da": "Submitted by",
  "fotografie": "PHOTOS",
  "check_giornalieri": "Daily checks",
  "esporta_csv": "Export to CSV",
  "elenco_check": "Check list",
  "autista": "Driver",
  "secondo_op": "Assistant",
  "orario_non_valido": "Time is not valid",
  "km": "km",
  "acqua": "Water",
  "olio": "Oil",
  "immagini_caricate": "Uploaded images",
  "azioni": "Actions",
  "contratto": "Contract",
  "dati_contratto": "Contract data",
  "codice_contratto": "Contract code",
  "cliente": "Client",
  "valido_fino_a": "Valid until",
  "prezzo": "Price",
  "gestore": "Manager",
  "email_di_notifica": "Notification email",
  "azienda": "Company",
  "numero_operatori": "Number of operators",
  "minuti_fermo_auto": "Minutes stopped car",
  "aggiungi_cap": "Add ZIP code",
  "prepagato_utenti": "Prepaid for APP and Website users",
  "andata_ritorno": "Round trip",
  "indietro": "Back",
  "salva": "Save",
  "opportunita": "Prospect",
  "codice": "Code",
  "valido_fino": "Valid until",
  "aggiungi_gestore": "Add a manager",
  "dati_gestore": "Manager data",
  "nome": "First Name",
  "cognome": "Last Name",
  "email": "Email",
  "password_primo_accesso": "First access password",
  "gestori": "Managers",
  "super_gestore": "Super manager",
  "abilita_super_gestore": "Can see associated managers",
  "gestori_associati": "Associated managers",
  "seleziona_gestori": "Select Manager",
  "permessi_super": "Associated managers' visible sections",
  "flotta": "Fleet",
  "nessun_gestore": "No managers",
  "viaggio_giornaliero": "Daily trip",
  "dati_viaggio": "Trip data",
  "assegna_autista": "Assign a driver",
  "nome_passeggero": "Name and surname",
  "indirizzo_partenza": "Departure address",
  "indirizzo_arrivo": "Arrival address",
  "orario_presa": "Pick-up time",
  "valida_fino_al": "Valid until",
  "quali_giorni": "Which days of the week will the ride be made?",
  "lun": "Mon",
  "mar": "Tue",
  "mer": "Wed",
  "gio": "Thu",
  "ven": "Fri",
  "sab": "Sat",
  "dom": "Sun",
  "viaggi_giornalieri": "Daily trips",
  "aggiungi": "Add",
  "esporta": "Export",
  "viaggi_inseriti_description": "Trips entered in the \"Daily trips\" section, every Friday afternoon they will be automatically scheduled for the following week, from Monday to Sunday, leaving 3 days for any pre-service changes.",
  "elenco_corse_giornaliere": "List of daily races",
  "cerca_per_nome": "Search by name, manager, time or address",
  "giorni": "Days",
  "passeggero": "Passenger",
  "partenza": "Departure",
  "arrivo": "Arrival",
  "orario": "Time",
  "nessun_viaggio_ricorrente": "No recurring trips scheduled",
  "data": "Date",
  "stato": "Status",
  "rifiutato": "Refused",
  "inserito": "Added",
  "assegnato": "Assigned",
  "vicino_casa": "Near home",
  "arrivato": "Arrived",
  "annullato": "Cancelled",
  "a_bordo": "On board",
  "provenienza": "Origin",
  "dettagli": "Details",
  "storico": "History",
  "cerca": "Search",
  "data_da": "Date from",
  "data_a": "Date to",
  "nessun_viaggio_in_corso": "No Ongoing Trips",
  "viaggi_pianificati": "Planned trips",
  "accedi": "Log in",
  "password": "Password",
  "password_dimenticata": "Forgot your password?",
  "entra": "Enter",
  "reimposta_password": "Reset password",
  "reimposta": "Reset",
  "mappa": "Map",
  "aggiungi_mezzo": "Add vehicle",
  "dati_mezzo": "Vehicle data",
  "targa": "License plate",
  "km_attuali": "Current kilometers",
  "data_revisione": "Revision date",
  "data_omologazione": "Approval date",
  "data_assicurazione": "Insurance date",
  "dati_amministrativi": "Administrative data",
  "registration_date": "Registration date",
  "euro_class": "Euro class",
  "ownership_type": "Ownership type",
  "ownership_expiry": "Ownership expiry",
  "tyre_type": "Tyre type",
  "permessi_licenze": "Permits & Licenses",
  "dotazioni_di_bordo": "Onboard equipment",
  "numero": "Number",
  "manutenzione": "Maintenance",
  "interventi": "services",
  "dati_intervento": "Service data",
  "nuovo_intervento": "New service",
  "modifica_intervento": "Edit service",
  "nessun_intervento": "No service",
  "sicuro_rimuovi_intervento": "Delete this service?",
  "fornitore": "Supplier",
  "prossima_scadenza": "Next due",
  "prossime_scadenze": "Upcoming deadlines",
  "next_due_km": "Next due km",
  "next_due_date": "Next due date",
  "scadenza": "Deadline",
  "scadenzario": "Fleet deadlines",
  "scadenze_manutenzione": "Maintenance and document deadlines",
  "nessuna_scadenza": "No deadline found",
  "categoria": "Category",
  "deadline_ok": "Compliant",
  "deadline_in_scadenza": "Due soon",
  "deadline_scaduto": "Expired",
  "deadline_cat_maintenance": "Maintenance",
  "deadline_cat_vehicle": "Vehicle",
  "deadline_cat_permit": "Permit",
  "deadline_cat_equipment": "Equipment",
  "foto": "Photos",
  "integrazioni": "Integrations",
  "provider_gps": "GPS/Telemetry provider",
  "provider_ocr": "Invoice OCR provider",
  "api_key": "API key",
  "nessuno": "None",
  "salva_prima_di_aggiungere_foto": "Save the event before adding photos",
  "mezzi_aziendali": "Company vehicles",
  "elenco_mezzi": "List of vehicles",
  "aggiungi_cliente_in_rubrica": "Add client to address book",
  "dati_cliente": "Customer data",
  "telefono": "Phone",
  "cod_fisc": "Fiscal code",
  "indirizzo_preferito": "Preferred address",
  "rubrica_clienti": "Customer address book",
  "scarica_lista": "Download list",
  "importa_da_ordini": "Import",
  "nessun_cliente_in_rubrica": "No clients in address book",
  "patente": "License",
  "aggiungi_autista": "Add driver",
  "elenco_autisti": "List of drivers",
  "aggiungi_evento": "Add an event",
  "modifica_evento": "Edit event",
  "da": "From",
  "a": "To",
  "elimina": "Delete",
  "foto_autista": "Driver's photo",
  "trascina_qui": "Drag here or click to select driver's photo",
  "numero_patente": "License number",
  "valore_associato": "Associated value",
  "scegli_mezzo": "Choose a vehicle",
  "indirizzo": "Address",
  "indirizzo_email": "Email Address",
  "num_telefono": "Phone Number",
  "aggiungi_cliente": "Add Customer",
  "dalle": "From",
  "alle": "To",
  "destinazione": "Destination",
  "orario_partenza": "Departure time",
  "pulmino_centro_diurno": "Daycare center minibus",
  "pulmino": "Minubus",
  "elenco_presenze": "Attendance list",
  "segna_come_assente": "Mark as absent",
  "rimuovi_utente": "Remove user",
  "nessun_viaggio_pulmino": "No trips on this minibus",
  "aggiungi_viaggio": "Add a trip",
  "dati_del_viaggio": "Trip details",
  "date_del_viaggio": "Date or dates of the trip",
  "orario_viaggio": "Trip time",
  "prezzo_viaggio": "Trip price",
  "prezzo_allettato": "Bedridden fare",
  "tempo_viaggio": "Est. time",
  "email_di_contatto": "Contact email",
  "data_ritorno": "Return date",
  "riepilogo": "Summary",
  "link_pagamento": "Payment link",
  "viaggio": "Trip",
  "service_mode": "Service type",
  "service_mode_transport": "Transport",
  "service_mode_transport_objects": "Object transport",
  "service_mode_ambulance": "Ambulance",
  "service_mode_assistance": "Assistance",
  "service_mode_train": "Train",
  "prenotazioni": "Bookings",
  "prenotazione": "Booking",
  "prenotazioni_sub": "Multimodal services",
  "nessuna_prenotazione": "No bookings",
  "nuova_prenotazione": "New booking",
  "aggiungi_servizio": "Add service",
  "servizio": "Service",
  "servizi": "Services",
  "nessun_servizio": "No service configured",
  "contract_services_hint": "The contract only applies to bookings requesting exactly these services. Leave empty for a single-service contract.",
  "contract_service_price_placeholder": "Empty = contract price",
  "percentuale": "Percentage (%)",
  "seleziona": "Select...",
  "privato": "Private",
  "rubrica": "Address book",
  "cerca_azienda": "Search company…",
  "cerca_cliente": "Search customer…",
  "totale": "Total",
  "distanza": "Distance",
  "mappa_hint": "Fill at least two stops to see the map.",
  "modello_prezzo": "Pricing model",
  "pricing_manual": "Manual",
  "pricing_fixed": "Fixed price",
  "pricing_mbility": "Standard mbility",
  "pricing_custom_api": "Custom API",
  "api_url": "Pricing API URL",
  "tariffa_base": "Rate",
  "soglia_ar_km": "Round-trip threshold (km)",
  "moltiplicatori": "Multipliers",
  "mult_weekend": "Weekend (e.g. 1.2)",
  "mult_night": "Night (e.g. 1.3)",
  "mult_double_operator": "Double operator",
  "addizioni": "Additions",
  "add_dismissal": "Dismissal (€)",
  "add_require_wheelchair": "Wheelchair (€)",
  "prezzo_fisso": "Fixed price (€)",
  "prezzo_base": "Base price",
  "prezzo_km": "€/km",
  "prezzo_min": "€/min",
  "campi_personalizzati": "Custom fields",
  "aggiungi_campo": "Add field",
  "nessun_campo": "No custom fields.",
  "chiave": "Key",
  "etichetta": "Label",
  "opzioni_csv": "Options (comma-separated)",
  "obbligatorio": "Required",
  "mostra_per_modalita": "Show for modes (empty = all)",
  "calcolo_prezzo": "Computing price…",
  "calcola_prezzo": "Calculate price",
  "prezzo_calcolato": "Price computed by provider",
  "usa_prezzo_calcolato": "Use computed price",
  "percorso_incompleto": "Complete the route to calculate the price",
  "config_prenotazioni": "Booking config",
  "stazione_partenza": "Departure station",
  "stazione_arrivo": "Arrival station",
  "numero_treno": "Train number",
  "percorso": "Route",
  "modifica_servizio": "Edit service",
  "servizi_offerti": "Offered services",
  "nessun_dettaglio": "No details available",
  "data_primo_servizio": "First service date",
  "fermo_auto_minuti": "Waiting time (minutes)",
  "item_type": "Item type",
  "item_type_documents": "Documents",
  "item_type_parcel": "Parcel",
  "item_type_medical_supplies": "Medical supplies",
  "item_type_luggage": "Luggage",
  "item_type_other": "Other",
  "weight_kg": "Weight (kg)",
  "dimensions": "Dimensions (LxWxH cm)",
  "fragile": "Fragile",
  "stretcher": "Stretcher",
  "wheelchair_required": "Wheelchair required",
  "oxygen_required": "Oxygen",
  "medical_escort": "Medical escort",
  "medical_escort_none": "None",
  "medical_escort_nurse": "Nurse",
  "medical_escort_doctor": "Doctor",
  "patient_condition": "Patient condition",
  "duration_minutes": "Duration (minutes)",
  "assistance_type": "Assistance type",
  "assistance_type_companionship": "Companionship",
  "assistance_type_errands": "Errands",
  "assistance_type_hospital": "Hospital assistance",
  "assistance_type_other": "Other",
  "carriage": "Carriage",
  "seat": "Seat",
  "prm_assistance": "PRM assistance (Sala Blu)",
  "campo_obbligatorio": "Required field",
  "data_obbligatoria": "Date is required.",
  "stazioni_obbligatorie": "Departure/arrival stations are required.",
  "indirizzo_obbligatorio": "Address is required.",
  "indirizzi_obbligatori": "Departure/arrival addresses are required.",
  "tempo": "Time",
  "booking_status_draft": "Draft",
  "booking_status_confirmed": "Confirmed",
  "booking_status_in_progress": "In progress",
  "booking_status_completed": "Completed",
  "booking_status_partial": "Partial",
  "booking_status_cancelled": "Cancelled",
  "NON": "NO",
  "fermo_auto": "Car stop",
  "note": "Notes",
  "sicuro_annullare": "Are you sure you want to cancel the trip?",
  "modifica_non_reversibile": "The modification is not reversible and the cancellation email will be sent to the customer.",
  "no_annulla": "NO, CANCEL",
  "annulla_selezionati": "Cancel selected",
  "si_elimina": "YES, DELETE",
  "calendario": "Calendar",
  "pianificazione": "Planning",
  "filtra_autista": "Filter by driver",
  "agg_viaggio": "Add trip",
  "colori_descr": "Company colors appear only on trips booked by the customer in B2B dashboard",
  "data_ora": "Date and Time",
  "chiudi": "CLOSE",
  "copia": "COPY",
  "modifica": "EDIT",
  "elimina_": "DELETE",
  "canale": "Channel",
  "autonomo": "Independent with signed waiver",
  "nascondi_assegnati": "Hide assigned trips",
  "nascondi_pianificati": "Hide planned trips",
  "nascondi_disponibili": "Hide available",
  "viaggi_in_corso": "Ongoing trips",
  "raggruppa": "GROUP",
  "viaggi_nei_prossimi_giorni": "Trips in the next few days",
  "nessun_viaggio_previsto": "No trips planned",
  "scegli_colore": "Choose a color",
  "stato_pagamento": "Payment status",
  "ci_sono": "There are",
  "richieste_di_soccorso": "emergency requests!",
  "logout": "Logout",
  "gestionale": "Management system",
  "dashboard": "Dashboard",
  "analytics": "Analytics",
  "mezzi": "Vehicles",
  "clienti": "Customers",
  "check_mezzo": "Vehicle check",
  "contratti": "Contracts",
  "imposta": "Set",
  "numero_fattura": "Invoice number",
  "autisti": "Drivers",
  "contratti_attivi": "Active contracts",
  "aggiungi_contratto": "Add contract",
  "nessun_contratto_attivo": "No active contract",
  "cod_contratto_obbligatorio": "Contract code is mandatory",
  "prezzo_contratto_obbligatorio": "Contract price is mandatory",
  "cliente_contratto_obbligatorio": "Contract client is mandatory",
  "data_contratto_obbligatorio": "Contract end date is mandatory",
  "inserimento_contratto": "Contract insertion",
  "aggiornamento_contratto": "Contract update",
  "cap_non_valido": "Invalid ZIP code",
  "nome_non_valido": "Invalid name",
  "cognome_non_valido": "Invalid surname",
  "password_non_valida": "Invalid password",
  "email_non_valida": "Invalid email format",
  "nome_passeggero_mancante": "Missing passenger name.",
  "cognome_passeggero_mancante": "Missing passenger surname.",
  "indirizzo_partenza_non_valido": "Invalid departure address.",
  "indirizzo_arrivo_non_valido": "Invalid arrival address.",
  "orario_presa_formato": "Pick-up time must be in HH:mm format.",
  "data_viaggio_non_presente": "Trip date not provided",
  "indirizzo_di_partenza_non_valido": "Invalid departure address",
  "indirizzo_di_arrivo_non_valido": "Invalid arrival address",
  "prezzo_non_valido": "Invalid price",
  "riepilogo_error": "To send the summary to the user, you need to provide their email address.",
  "pagato": "paid",
  "cliente_ordine": "The customer placed the order on: ",
  "ordine_inserito": "Order inserted: ",
  "cliente_richiede": "The customer requests the service for: ",
  "data_servizio": "Service date: ",
  "vuoi_cancellare_ordine": "Do you want to cancel the order?",
  "inserisci_email": "Enter an email address",
  "errore_generico": "Generic error. Please try again later",
  "email_inviata": "We have sent you an email with instructions to change your password",
  "sicuro_rimuovi_mezzo": "Are you sure you want to remove the vehicle with license plate: ",
  "km_non_validi": "Invalid kilometers",
  "targa_non_valida": "Invalid license plate",
  "data_revisione_non_valida": "Invalid revision date",
  "data_omologazione_non_valida": "Invalid homologation date",
  "data_assicurazione_non_valida": "Invalid insurance date",
  "telefono_non_valido": "Invalid phone number",
  "patente_non_valida": "Incorrect format for license number (10 characters required)",
  "password_non_valida_char": "Password must contain at least 8 characters",
  "tipo_file_errato": "Incorrect file type",
  "sicuro_annulla": "Are you sure you want to cancel the order?",
  "italiano": "Italian",
  "inglese": "English",
  "proposta_ottimizzazione": "Optimization proposal",
  "nessuna_ottimizzazione": "Trips are already optimized",
  "conferma": "Confirm",
  "data_ricezione": "Date received",
  "gps_serial": "GPS Serial",
  "data_ricezione_non_valida": "Invalid date received",
  "sicuro_rimuovi": "Confirm your cancellation?",
  "sicuro_rimuovi_permanente": "Confirm your cancellation? Once canceled, it cannot be restored",
  "viaggi_effettuati": "Trips done",
  "nessun_autista": "No Driver",
  "carrozzina": "Wheelchair Users",
  "no_carrozzina": "No Wheelchair Users",
  "persone": "people",
  "accompagnatori": "Companions",
  "invia": "Send",
  "sel-autista": "Select Driver",
  "segna_presenza": "Mark as present",
  "gestisci_assenze": "Absences",
  "nessun_assenza": "No Absences",
  "vicini": "Drivers nearby",
  "timeline": "Timeline",
  "allettati": "Bedridden",
  "ora_ritorno": "Return Time",
  "vuoi_cancellare_anche_andata": "There is a return trip associated with this trip, also cancel the return?",
  "vuoi_cancellare_anche_ritorno": "This trip is a return trip, should I also cancel the outward journey?",
  "modifica_andata": "Change Outward Trip",
  "modifica_ritorno": "Change Return Trip",
  "totale_transato_singoli": "Single trip revenue",
  "totale_viaggi_singoli": "Single trip rides",
  "totale_transato_cd": "Group trip revenue",
  "totale_viaggi_cd": "Group trip rides",
  "a_partire_da": "Start From: ",
  "giorno_visualizzato": "Day: ",
  "impersona_utenti": "Impersonate Users",
  "custom_token": "Custom Token",
  "ruolo": "Role",
  "impersona": "Impersonate",
  "id": "ID",
  "company": "Company",
  "aggiungi_utente_gestore": "Add Manager User",
  "utenti_gestori": "Manager Users",
  "name": "Name",
  "opzioni_gestore": "Manager Options",
  "visualizza_inseriti": "View Unassigned Trips",
  "opzioni_admin": "Admin Options",
  "visualizza_in_timeline": "View in Timeline",
  "visualizza_in_calendario": "View in Calendar",
  "visualizza_in_lista": "View in List",
  "mostra_autisti": "Show Drivers",
  "nascondi_altri_gestori": "Hide Other Managers",
  "in_carrozzina": "Wheelchair User",
  "code": "Code",
  "color": "Color",
  "companies": "Companies",
  "aziende_aggregate": "Aggregated companies",
  "aziende_aggregate_hint": "Selected companies are aggregated: their custom fields and data flow into this multi company.",
  "seleziona_aziende": "Select companies...",
  "aggiungi-company": "Add Company",
  "aggiungi_company": "Add Company",
  "elenco_companies": "Company List",
  "dati_company": "Company Data",
  "label": "Display Name",
  "address": "Address",
  "orario_ingresso": "Check-in Time",
  "orario_uscita": "Check-out Time",
  "dati_fatturazione": "Billing Data",
  "codice_fiscale": "Tax Code",
  "codice_sdi": "SDI Code",
  "denominazione": "Company Name",
  "p_iva": "VAT Number",
  "sede_legale": "Registered Office",
  "cap": "Postal Code",
  "civico": "Street Number",
  "comune": "Town",
  "nazione": "Country",
  "provincia": "Province",
  "mattina": "Morning",
  "pomeriggio": "Afternoon",
  "lunedi": "Monday",
  "martedi": "Tuesday",
  "mercoledi": "Wednesday",
  "giovedi": "Thursday",
  "venerdi": "Friday",
  "gruppo": "Group",
  "ottimizza_viaggi": "Optimize Trips",
  "giorno": "Day",
  "daytime": "Time of Day",
  "viaggi": "Trips",
  "seleziona_giorno": "Select Day",
  "seleziona_daytime": "Select Time of Day",
  "ottimizza": "Optimize",
  "annulla": "Cancel",
  "orario_minimo": "Minimum Start Time",
  "report_assenze": "Export Monthly Absence Report",
  "aggiungi_utente": "Add User",
  "seleziona_mese": "Select Month",
  "seleziona_anno": "Select Year",
  "mese": "Month",
  "anno": "Year",
  "preferenza_orario": "Time Preference",
  "aggiungi_in_gruppo": "Add to Group",
  "aggiungi_ricalcola": "Add and Recalculate Routes",
  "vecchio_orario": "Old Time",
  "nuovo_orario": "New Time",
  "tutto_il_giorno": "All Day",
  "tutti_i_giorni": "Every Day",
  "gestione_viaggi_azienda": "Company Travel Management",
  "ricerca": "Cerca",
  "pendings": "Pending Requests",
  "email_utenti_cd": "Send Email for Users",
  "email_giri_cd": "Send Email for Vans",
  "email_inviata_cd": "Email Sent",
  "nome_operatore": "Operator Name",
  "num_orders": "Number of Bookings",
  "total_price": "Revenue",
  "fatturato": "Revenue",
  "classifica_operatori": "Operator Ranking",
  "gennaio": "January",
  "febbraio": "February",
  "marzo": "March",
  "aprile": "April",
  "maggio": "May",
  "giugno": "June",
  "luglio": "July",
  "agosto": "August",
  "settembre": "September",
  "ottobre": "October",
  "novembre": "November",
  "dicembre": "December",
  "users": "Users",
  "tutte_le_aziende": "All Companies",
  "fatturato_medio_per_prenotazione": "Average Revenue per Booking",
  "home": "Home",
  "operators": "Operators",
  "count_orders": "Number of Bookings",
  "new_users": "New Users",
  "inbound_calls": "Inbound Calls",
  "grouping_criteria": "Source",
  "management_site": "Management Site",
  "grouped_rides": "Group Rides",
  "other_managers": "Other Managers",
  "b2b_dashboard": "B2B Dashboard",
  "website": "Website",
  "nessuna_fonte": "No Source",
  "densita_toolbar": "Density",
  "private_users": "Private Users",
  "other_companies_users": "Users from Other Companies",
  "managers": "Managers",
  "answered_calls": "Answered Calls",
  "contractStatus": "Contract Status",
  "contractCode": "Contract Code",
  "contractEndDate": "Contract End Date",
  "contractStartDate": "Contract Start Date",
  "contractPrice": "Contract Price",
  "actions": "Actions",
  "type": "Type",
  "required": "Required",
  "read_only": "Read Only",
  "size": "Size",
  "class_type": "Class Type",
  "modifica_company": "Modify Company",
  "add_field": "Add Field",
  "field_name": "Field Name",
  "field_type": "Field Type",
  "field_label": "Field Label",
  "field_required": "Required",
  "field_read_only": "Read Only",
  "field_size": "Size",
  "field_class_type": "Class Type",
  "customFields": "Custom Fields",
  "noFields": "No Fields",
  "addField": "Add Field",
  "types": "Types",
  "prezzo_utente": "User Price",
  "cdi": "Daycare Center",
  "vans": "Assigned Vehicles",
  "yes": "Yes",
  "no": "No",
  "active": "Active",
  "contracts": "Contracts",
  "noContracts": "No Contract",
  "field_name_placeholder": "Insert Field Name",
  "field_type_placeholder": "Select Field Type",
  "field_label_placeholder": "Insert Field Label",
  "field_size_placeholder": "Insert Field Size",
  "field_class_type_placeholder": "Select Field Class Type",
  "inactive": "Inactive",
  "multiple": "Multiple Options",
  "hidden": "Hidden",
  "edit_field": "Edit Field",
  "delete_field": "Delete Field",
  "dependencies": "Dependencies",
  "options_for_select": "Options for Select",
  "default_value": "Default Value",
  "num_prospect": "Prospect Number",
  "nessun_operatore": "No Operator",
  "seleziona_centro_diurno": "Select Daycare Center",
  "momento_della_giornata": "Time of Day",
  "vuoi_attivare_ordine": "Do you want to activate the order?",
  "attiva_ordine": "Activate the order",
  "centri_diurni": "Daycare Centers",
  "seleziona_tipo": "Select Type",
  "add-trips": "Add Trips",
  "reset_filtri": "Reset Filters",
  "add": "Add",
  "seleziona_viaggi_da_aggiungere": "Select Trips to Add",
  "showCount": "Number of Trips",
  "showRevenue": "Revenue",
  "showActual": "Show Actual",
  "showForecast": "Show Forecast",
  "showGroupCount": "Number of Groups",
  "editMode": "Edit Mode",
  "editForecast": "Edit Forecast",
  "editActual": "Edit Actual",
  "none": "Off",
  "new_Company": "New Forecast Company",
  "new_forecast": "New Forecast",
  "company_name": "Company Name",
  "type_forecast": "Forecast Type",
  "count": "Number of Trips",
  "revenue": "Revenue",
  "january": "January",
  "february": "February",
  "march": "March",
  "april": "April",
  "may": "May",
  "june": "June",
  "july": "July",
  "august": "August",
  "september": "September",
  "october": "October",
  "november": "November",
  "december": "December",
  "analytics_details": "Analytics Details",
  "total_90": "Total Without VAT",
  "total_10": "VAT (10%)",
  "avg": "Average Trip Cost",
  "total": "Total",
  "total_carried_persons": "Total Passengers",
  "avg_carried_persons": "Average Passengers",
  "total_car_pooled": "Total Pooling Trips",
  "total_not_car_pooled": "Total Non Pooling Trips",
  "avg-price": "Average Trip Cost",
  "viewMode": "View Mode",
  "report_vehicles": "Report Vehicles",
  "custom_interval": "Custom Interval",
  "select_interval": "Select Interval",
  "seleziona_mezzo": "Select Vehicle",
  "ricarica": "Reload",
  "vehicles": "Vehicles",
  "mezzo": "Vehicle",
  "inizio": "Start",
  "fine": "End",
  "durataGuida": "Driving Time",
  "tempoFermo": "Parking Time",
  "durataGuida_s": "Driving Time",
  "tempoFermo_s": "Parking Time",
  "showDailyTrips": "Scheduled",
  "available": "Available",
  "pause": "Pause",
  "extra": "Extra",
  "vacation": "Vacation",
  "sick": "Sick",
  "non disponibile": "Not Available",
  "malattia": "Sick",
  "straordinario": "Extra",
  "fleet": "Fleet",
  "hub": "Hub",
  "ferie": "Vacation",
  "pausa": "Pause",
  "default-targa": "Not Assigned",
  "nuovo-turno": "New Turn",
  "assegna-veicolo ": "Assign Vehicle ",
  "orari_autisti": "Driver Schedule",
  "nuovo_viaggio": "New Trip",
  "nuova_ambulanza": "New Ambulance",
  "nuova_assistenza": "New Assistance",
  "nuovo_treno": "New Train",
  "nuovo_trasporto_oggetti": "New Object Transport",
  "nuovo_turno": "New Turn",
  "nuovo_evento": "New Event",
  "luogo": "Place",
  "si": "Yes",
  "oggi": "Today",
  "abilita_modifica_shift": "Modify Shift",
  "ordini_altri_gestori": "{{count}} orders in other managers",
  "timeline_saturation": "Saturation",
  "timeline_saturation_aria": "Saturation {{pct}}%: {{occupied}} busy out of {{shift}} shift time",
  "timeline_saturation_no_shift": "No shift",
  "timeline_occupied_time": "Occupied time",
  "timeline_extra_time": "of which extra",
  "timeline_legend": "Service mode legend",
  "timeline_mode_filter_reset": "All modes",
  "giorno_precedente": "Previous day",
  "ora_precedente": "Previous hour",
  "ora_successiva": "Next hour",
  "giorno_successivo": "Next day",
  "visualizza_analisi": "Show analysis",
  "duration_ride": "Ride duration",
  "timeline_color_legend": "Color legend",
  "timeline_deadhead": "Travel time",
  "timeline_event_time": "Events",
  "filtri": "Filters",
  "timeline_subtitle": "Dispatch and daily planning",
  "vehicle_assignment": "Vehicle assignment",
  "timeline_show_past_travel": "Past travel times",
  "timeline_show_delays": "Show delays and earlies",
  "color_default": "Standard",
  "color_planned": "Planned",
  "color_planned_override": "Planned with exception",
  "color_planned_op2": "Planned — 2nd operator",
  "color_app": "App booking",
  "color_assistance": "Assistance",
  "color_cancelled": "Cancelled",
  "color_refused": "Refused",
  "color_absent": "Absent",
  "color_delay": "Delay (pickup or drop-off)",
  "color_early": "Early (pickup or drop-off)",
  "color_company_note": "Company/contract color when set",
  "real_departure": "Actual departure",
  "real_arrival": "Actual end",
  "scheduled_time": "Scheduled time",
  "real_time": "Actual time",
  "estimated_time": "Estimated time",
  "arrivo_previsto": "Planned arrival",
  "estimated_end": "Estimated end",
  "delay": "Delay",
  "early": "Early",
  "seat_occupancy": "Seat occupancy",
  "over_capacity": "Over capacity",
  "wheelchair_over_capacity": "Wheelchair capacity exceeded",
  "no_vehicle_assigned": "No vehicle assigned",
  "requires_ambulance": "Requires ambulance",
  "senza_hub": "No hub",
  "filtra_hub": "Filter by hub",
  "vai_al_giorno": "Go to day",
  "manager-unknown": "Unknown Manager",
  "dettagli_viaggio": "Trip Details",
  "da_incassare": "To be Collected",
  "showTraffic": "Show Traffic",
  "passeggeri": "Passengers",
  "visualizza gruppo": "View Group",
  "distance": "Distance",
  "duration": "Duration",
  "showStops ▼": "Show Stops ▼",
  "hideStops ▲": "Hide Stops ▲",
  "from": "From",
  "to": "To",
  "elenco_viaggi": "Trip List",
  "Filtra Per Data": "Filter by Date",
  "Totale Corse": "Total Trips",
  "Totale Fatturato": "Total Revenue",
  "Minuti Totali Fermo Auto": "Total Parking Time",
  "Fatturato Fermo Auto": "Parking Revenue",
  "capacità": "Capacity",
  "capacità_carica": "Charge Capacity",
  "hub_aziendali": "Hub Company",
  "aggiungi_hub": "Add Hub",
  "elenco_hub": "Hub List",
  "nessun_hub": "No Hub",
  "hub_aziendale": "Hub Company",
  "modifica_hub": "Modify Hub",
  "dati_hub": "Hub Data",
  "informazioni_base": "Base Data",
  "assegnazione_gestore": "Assign Manager",
  "documenti": "Documents",
  "carica": "Upload",
  "carica_altri": "Load more",
  "modifica_autista": "Modify Driver",
  "elimina_autista": "Delete Driver",
  "vista_autista": "Driver live view",
  "account": "Account",
  "dati_autista": "Driver Data",
  "seleziona_gestore": "Select Manager",
  "dati_contatto": "Contact Data",
  "modello": "Model",
  "marca": "Brand",
  "km_omologazione": "Km of Registration",
  "nessun_mezzo": "No Vehicle",
  "tipo": "Type",
  "posti": "Seats",
  "posti_short": "seats",
  "posti_carrozzina_short": "wheelchair",
  "tipologia_non_assegnata": "No type assigned",
  "posti_carrozzina": "Wheelchair Seats",
  "modifica_mezzo": "Modify Vehicle",
  "assegnazioni": "Assignments",
  "assegnato_a": "Assigned to",
  "assegnati_oggi": "Assigned today",
  "assegnazione_tutte": "Assigned and free",
  "mezzo_libero": "Free",
  "mezzi_liberi": "Free",
  "tracciamento_gps": "GPS Tracking",
  "percorsi": "Routes",
  "percorsi_del_mese": "Routes of the month",
  "km_totali": "Total km",
  "nessun_percorso": "No route in the period",
  "gps_non_configurato": "GPS integration not configured",
  "autisti_fulltime": "Full-Time drivers",
  "autisti_parttime": "Part-Time drivers",
  "autisti_fte": "Drivers FTE",
  "accompagnatori_fte": "Companions FTE",
  "totale_fte": "Total FTE",
  "accompagnatore": "Companion",
  "vedi_dettaglio_autisti": "See who is included in the count",
  "dettaglio_autisti_disponibili": "Available drivers breakdown",
  "ore_non_impostate": "hours not set",
  "fte_stimato_chip": "FTE estimated from contract",
  "fte_stimati_dettaglio_nota": "in this list have no usable contract hours: they count as 1 FTE, 0.5 if part-time.",
  "nessun_autista_in_questo_gruppo": "No available driver in this group with the current filters.",
  "fte_stimati_nota": "without usable contract hours: counted as 1 (0.5 if part-time)",
  "autisti_disponibili_nota_filtri": "Count over every visible driver: press Apply to narrow it to managers and commesse.",
  "gps_attivita": "Activity",
  "gps_tragitto_n": "Drive {{n}}",
  "gps_mezzo_fermo": "Vehicle parked",
  "gps_fine_attivita": "End of activity",
  "vedi_percorso": "View route",
  "percorso_sulla_mappa": "On the map",
  "mostra_tutto_il_percorso": "Show the whole track",
  "gps_vedi_posizione": "View location",
  "gps_nessuna_attivita": "No activity in the period",
  "gps_in_movimento": "Moving",
  "gps_soste": "Stops",
  "gps_non_configurato_desc": "Enter the GPS serial of the vehicle's device, or set the GPS provider = SafeFleet on the vehicle's manager.",
  "safefleet_id_mancante": "SafeFleet vehicle ID missing",
  "safefleet_id_mancante_desc": "Enter the GPS serial of the vehicle's device, or the SafeFleet vehicle ID in the vehicle's administrative data.",
  "safefleet_vehicle_id": "SafeFleet vehicle ID",
  "posti_sedere": "Seats",
  "seats": "Seats",
  "wheelchair_filling": "Wheelchair Seats",
  "max_wheelchair_seats": "Max Wheelchair Seats",
  "date_tecniche": "Technical Data",
  "centerVehicle": "Center Vehicle",
  "gestione_turni_autisti": "Driver shift management",
  "filtra_per_gestore": "Filter by manager",
  "nome_o_cognome": "First or last name",
  "vehicle_cleaning": "Vehicle cleaning",
  "vehicle_charge": "Vehicle charging",
  "vehicle_maintenance": "Vehicle maintenance",
  "course": "Training course",
  "andata_a_vuoto": "Empty outbound trip",
  "ritorno_a_vuoto": "Empty return trip",
  "vuoto_collegato_hint": "Long trip: adds the driver's empty leg, linked to the service. Requires an assigned driver.",
  "ar_non_disponibile": "Round trip not available with vehicle wait or with empty legs.",
  "ritorno_dopo_fermo": "Return after vehicle wait (x2)",
  "viaggio_a_vuoto": "Empty trip",
  "autista_non_valido": "Select a driver for the empty trip",
  "informazioni_evento": "Event information",
  "tipo_evento": "Event type",
  "seleziona_data_ora": "Select date and time",
  "durata": "Duration (min)",
  "dati_trasporto": "Transport data",
  "distanza_km": "Distance (km)",
  "dati_conducente_veicolo": "Driver and vehicle details",
  "seleziona_autista": "Select driver",
  "seleziona_veicolo": "Select vehicle",
  "aggiungi_note": "Add notes",
  "dati_evento": "Event data",
  "dettagli_evento": "Event details",
  "durata_evento": "Event duration",
  "cancella": "Delete",
  "dotazioni_veicolo": "Vehicle features",
  "gestito_da": "Managed by",
  "aggiorna": "Update",
  "invia_riepilogo": "Send summary",
  "crea_fattura": "Create invoice",
  "stationed": "Stationed",
  "optimize": "Optimize",
  "tappa": "Stop",
  "ETA": "Estimated Time of Arrival",
  "status": "Status",
  "aggiungi_al_giro": "Add to route",
  "orario_inizio": "Start time",
  "ottimizza_percorso": "Optimize route",
  "viewOptimizedStops": "View optimized stops",
  "riassegna": "Reassign",
  "fake": "Fake",
  "backup": "Backup",
  "companion": "Companion",
  "commessa": "Contract/Tender",
  "nessun_viaggio_programmato": "No trips scheduled",
  "caricamento_timeline": "Loading timeline...",
  "nuova_attivita": "New activity",
  "turni": "Shifts",
  "orari": "Schedules",
  "assegna_veicolo": "Assign vehicle",
  "altro": "Other",
  "auto": "Auto",
  "bus": "Bus",
  "van": "Van",
  "ambulance": "Ambulance",
  "unavailable": "Unavailable",
  "maintenance": "Maintenance",
  "lost": "Lost",
  "wait_for_documents": "Wait for documents",
  "documenti_caricati_successo": "Documents uploaded successfully",
  "errore_upload": "Error during upload",
  "documento_eliminato_successo": "Document deleted successfully",
  "errore_eliminazione": "Error during deletion",
  "documento": "Document",
  "documenti_esistenti": "Existing documents",
  "ricevuta": "Receipt",
  "assegna": "Assign",
  "assegnazione": "Assignment",
  "elenco_assegnazioni": "Assignments list",
  "Ins.": "Ins.",
  "Serv.": "Serv.",
  "in attesa": "Pending",
  "pending": "Pending",
  "tratta": "Route",
  "prezzo_corsa": "Trip price",
  "prezzo_totale": "Total price",
  "imponibile": "Taxable amount",
  "totale_imponibile_corse": "Total taxable amount",
  "pagamento": "Payment",
  "stato_fatturazione": "Billing status",
  "b2c": "B2C",
  "non incassare": "Do not collect",
  "incassato": "Collected",
  "contestato": "Contested",
  "versato": "Banked",
  "rimborsato": "Refunded",
  "fallito": "Failed",
  "parziale": "Partial",
  "storno": "Reversal",
  "non fatturato": "Not to invoice",
  "errore": "Error",
  "b2b": "B2B",
  "tipo_pagamento": "Payment type",
  "contanti": "Cash",
  "carta": "Card",
  "fnmpay": "FNM Pay",
  "paypal": "PayPal",
  "bonifico": "Bank transfer",
  "consuntivo": "Proforma",
  "not_invoiced": "Not to invoice",
  "invoiced": "Invoiced",
  "partial": "Partial",
  "error": "Error",
  "totale_prezzo_corse": "Total Ride Price",
  "prezzo_totale_fermo_auto": "Total Waiting Price",
  "metodo_pagamento": "Payment method",
  "minuti_totali_fermo_auto": "Total Waiting Minutes",
  "totale_corse": "Total Rides",
  "non specificato": "Unspecified",
  "fattura": "Invoice",
  "domicilio_fiscale": "Tax domicile",
  "dati_destinatario_fattura": "Invoice recipient data",
  "attivo": "Active",
  "inattivo": "Inactive",
  "disabilitato": "Disabled",
  "cancellato": "Deleted",
  "sconosciuto": "Unknown",
  "viaggi_singoli": "Single trips",
  "pianificatore": "Planner",
  "utenti": "Users",
  "modifica_cliente": "Edit customer",
  "nuovo_cliente": "New customer",
  "note_operative": "Operational notes",
  "operative_notes": "Operational notes",
  "consensi": "Consents",
  "privacy": "Privacy",
  "accepted_date": "Acceptance date",
  "marketing": "Marketing",
  "note_interne": "Internal notes",
  "comunicazioni": "Communications",
  "telefonate": "Phone calls",
  "nessun_elemento": "No items",
  "nuova_email": "New email",
  "registra_chiamata": "Log call",
  "indirizzi": "Addresses",
  "nuovo_indirizzo": "New address",
  "barriere_architettoniche": "Architectural barriers",
  "fatture": "Invoices",
  "contabilita": "Accounting",
  "tributi": "Taxes",
  "pianificati": "Planned",
  "stato_e_sicurezza": "Status and safety",
  "mobility": "Mobility",
  "companions": "Companions",
  "anagrafica_e_contatti": "Personal data and contacts",
  "telefono_2": "Phone 2",
  "naz": "Nationality",
  "prov": "Province",
  "ambulatory": "Ambulatory",
  "wheelchair": "In wheelchair",
  "bedridden": "Bedridden",
  "lunedì": "Monday",
  "martedì": "Tuesday",
  "mercoledì": "Wednesday",
  "giovedì": "Thursday",
  "venerdì": "Friday",
  "sabato": "Saturday",
  "domenica": "Sunday",
  "tipo_viaggio": "Trip type",
  "barr_arch": "Architectural barriers",
  "barr_arch_part": "Architectural barriers (departure)",
  "barr_arch_arr": "Architectural barriers (arrival)",
  "tutti": "All",
  "senza_commessa": "No contract",
  "accompagnatore_richiesto": "Companion required",
  "in_salita": "Boarding",
  "in_discesa": "Alighting",
  "per_tutta_la_durata": "Whole trip",
  "require_wheelchair": "Requires wheelchair",
  "require_baby_seat": "Requires baby seat",
  "ritorno": "Return trip",
  "assistenza_note": "Assistance & Notes",
  "booking_reference": "Booking",
  "urbano": "Urban",
  "extra_urbano": "Extra-Urban",
  "nessun_campo_personalizzato": "No custom fields",
  "anteprima": "Preview",
  "nessun_viaggio_da_mostrare_attiva_almeno_un_giorno_e_imposta_orari": "No trips to display: enable at least one day and set the times",
  "seleziona_metodo": "Select method",
  "seleziona_stato": "Select status",
  "subtotale_calcolato": "Calculated subtotal",
  "totale_con_fermo_auto": "Total with car stop",
  "stato_fattura": "Invoice status",
  "seleziona_stato_fattura": "Select invoice status",
  "nessuna_fattura": "No invoices",
  "Pianificatore": "Planner",
  "planner.subtitle": "Plan and manage trips",
  "calcola prezzo": "Calculate price",
  "save": "Save",
  "unknownUser": "Unknown user",
  "newUser": "New user",
  "removeUser": "Remove user",
  "settimana_tipo": "Week type",
  "attiva_lun_ven": "Enable Mon–Fri",
  "ora_andata": "Outbound time",
  "selectExistingUser": "Select existing user",
  "azioni_copia": "Copy actions",
  "copia_da_partenza": "Copy from departure",
  "copia_da_arrivo": "Copy from arrival",
  "cdi_planning": "CDI planning",
  "pianificati_singoli": "Single scheduled trips",
  "history_title": "History",
  "history_log": "Activity log",
  "date": "Date",
  "action": "Action",
  "done_by": "Done by",
  "data_viaggio": "Trip date",
  "assignments": "Assignments",
  "Base Price": "Base price",
  "Tolls": "Tolls",
  "Extras": "Extras",
  "Double Operator": "Double operator",
  "Discount": "Discount",
  "secondo_operatore": "Second operator",
  "secondo_operatore_salita": "Second operator (pickup)",
  "secondo_operatore_discesa": "Second operator (drop-off)",
  "secondo_operatore_arrivo": "Second operator (arrival)",
  "orario_ritorno": "Return time",
  "copia_da_andata": "Copy from outbound",
  "indirizzo_da_ritorno": "Departure address (return)",
  "barr_arch_da_ritorno": "Architectural barriers (departure – return)",
  "indirizzo_a_ritorno": "Arrival address (return)",
  "barr_arch_a_ritorno": "Architectural barriers (arrival – return)",
  "ward": "Ward",
  "piano": "Floor",
  "stanza": "Room",
  "dimissione_firmata": "Signed discharge",
  "tipo_oggetti": "Object type",
  "unspecified": "Unspecified",
  "attesa_incasso": "Awaiting payment",
  "con_fermo_auto": "(With car stop)",
  "card": "Card",
  "cash": "Cash",
  "fnm_pay": "FNMPay",
  "bank_transfer": "Bank transfer",
  "post_paid": "Post-paid",
  "no_incasso": "No payment",
  "nessun_check": "No check",
  "data_controllo_acqua": "Water check date",
  "data_controllo_olio": "Oil check date",
  "data_igienizzazione": "Sanitization date",
  "Equipaggiamenti": "Equipment",
  "aggiungi equipaggiamento": "Add equipment",
  "elenco_equipaggiamenti": "Equipment list",
  "equipments": "Equipment",
  "dotazioni": "Equipment",
  "dotazioni_assegnate": "Assigned equipment",
  "dati_personali": "Personal details",
  "data_nascita": "Date of birth",
  "contatto_emergenza": "Emergency contact",
  "telefono_emergenza": "Emergency phone",
  "patente_da_corsi": "The number comes from the licence recorded under Fitness → Courses and certifications.",
  "corsi_da_tab": "16-hour course, KB and the other qualifications are recorded under Fitness → Courses and certifications.",
  "fuel_type": "Fuel",
  "fuel_diesel": "Diesel",
  "fuel_petrol": "Petrol",
  "fuel_electric": "Electric",
  "fuel_hybrid": "Hybrid",
  "fuel_lpg": "LPG",
  "fuel_cng": "CNG",
  "vin": "Chassis number (VIN)",
  "vin_non_valido": "A chassis number has 17 characters, without I, O and Q.",
  "vehicle_without_oxygen": "The service needs oxygen: the vehicle has none",
  "hint_posti_da_tipologia": "Seats and wheelchair places come from the vehicle type: edit the type to change them.",
  "hint_posti_senza_tipologia": "Without a vehicle type these values apply. Seats do not count the driver.",
  "hint_wheelchair_filling": "The third field says how many seats one wheelchair takes.",
  "tipologia_riallinea_mezzi": "On save, the seats of {{n}} vehicles of this type are updated: {{plates}}.",
  "dotazioni_autista": "Driver equipment",
  "dotazioni_mezzo": "Vehicle equipment",
  "equipaggiamento_di_bordo": "Onboard equipment",
  "dotazione": "Equipment",
  "presente": "Present",
  "nessuna_dotazione": "No equipment assigned",
  "aggiungi_dotazione": "Add equipment",
  "permessi": "Permits",
  "permessi_ztl": "Permits & ZTL",
  "nessun_permesso": "No permit",
  "aggiungi_permesso": "Add permit",
  "geofence": "Geofence",
  "seleziona_geofence": "Select geofence",
  "costo_euro": "Cost (€)",
  "interventi_label": "Services",
  "nessun_dato": "No data",
  "costo_totale": "Total cost",
  "costo_medio_mezzo": "Avg cost / vehicle",
  "costo_medio_km": "Avg cost / km",
  "costo_medio_intervento": "Avg cost / service",
  "costo_per_tipo_intervento": "Cost by service type",
  "costo_per_tipologia_mezzo": "Cost by vehicle type",
  "costo_per_anno_immatricolazione": "Cost by registration year",
  "KPI": "KPI",
  "attrezzature": "Tools",
  "segnalazioni": "Reports",
  "Estintore": "Fire extinguisher",
  "Tessera carburante": "Fuel card",
  "Viacard": "Viacard",
  "GPS": "GPS",
  "Telefono": "Phone",
  "SIM": "SIM card",
  "Modifica tipo": "Edit type",
  "Dati tipo": "Type data",
  "Attrezzatura": "Tool",
  "Codice": "Code",
  "Tipo": "Type",
  "Costo Orario": "Hourly cost",
  "Dotazioni Veicolo": "Vehicle equipment",
  "Dati Personali": "Personal data",
  "Corso16h": "16-hour course",
  "seleziona equipaggiamenti": "Select equipment",
  "Taglia Maglia": "Shirt size",
  "seleziona taglia maglia": "Select shirt size",
  "Taglia Pantaloni": "Trousers size",
  "seleziona taglia pantaloni": "Select trousers size",
  "Part Time": "Part time",
  "Ore Lavorative": "Working hours",
  "Aggiungi tipo": "Add type",
  "Attrezzature": "Equipment",
  "POS": "POS terminal",
  "pocket_mask": "Pocket mask",
  "cavo_22kw": "22kW cable",
  "chiave_poli": "Policlinico key",
  "scalino": "Step",
  "invia email": "Send email",
  "update": "Update",
  "payment_email": {
    "title": "Payment email",
    "send": "Send",
    "to": "To",
    "from": "From",
    "prezzo": "Price"
  },
  "history": "History",
  "field": "Field",
  "before": "Before",
  "after": "After",
  "avvisi": "Alerts",
  "Equipments": "Equipment",
  "manage": "Manage",
  "caricamento": "Loading…",
  "kpi": "KPI",
  "chiama": "Call",
  "invia_email": "Send email",
  "seleziona_contratto": "Select contract",
  "scegli": "Choose",
  "cancella_cliente": "Delete user",
  "solo_utenti_censiti": "Only registered users",
  "colore": "Color",
  "apri": "Open",
  "apri_ricevuta": "Open receipt",
  "aggiunto": "Added",
  "aggiunto da": "Added by",
  "codice_fiscale_non_valido": "Invalid tax code",
  "codice_fiscale_controllo_errato": "Wrong tax code: the check character doesn't match (typo?)",
  "codice_fiscale_nomi_invertiti": "First and last name look swapped compared to the tax code",
  "codice_fiscale_cognome_diverso": "The tax code doesn't match the last name (the last name gives \"{{expected}}\")",
  "codice_fiscale_nome_diverso": "The tax code doesn't match the first name (the first name gives \"{{expected}}\")",
  "inserisci_sigla_provincia": "Insert province code",
  "inserisci_sigla_nazione": "Insert country code",
  "compila_correttamente_tutti_i_campi": "Fill in all fields correctly",
  "ore": "hours",
  "eventi": "events",
  "shifts": "Shifts",
  "today": "Today",
  "inverti_indirizzi": "swap addresses",
  "inverti_indirizzi_ritorno": "swap return-trip addresses",
  "base_price": "Base price",
  "supplemento_passeggeri": "Passenger surcharge",
  "require_wheelchair_addition": "Wheelchair req",
  "dismissal_add": "Dismissal add",
  "night_time": "Night time",
  "double_operator": "Double operator",
  "discount": "Discount",
  "flyering": "Flyering",
  "nessun_contratto_disponibile": "No contract available for this company.",
  "rich_carrozzina": "Carriage request",
  "agg_dimissione": "Dismissal addition",
  "weekend": "Weekend",
  "notturno": "Night",
  "doppio_operatore": "Double operator",
  "sconto": "Discount",
  "fatturazione": "Billing",
  "conferma_creazione": "Confirm creation",
  "wheelchair_request": "Wheelchair request",
  "discharge_surcharge": "Discharge surcharge",
  "night_service": "Night service",
  "Prezzo base": "Base price",
  "Rich. carrozzina": "Wheelchair request",
  "Agg. Dimissione": "Discharge surcharge",
  "Weekend": "Weekend",
  "Notturno": "Night service",
  "Doppio operatore": "Double operator",
  "Sconto": "Discount",
  "fermo_auto_incluso": "Included waiting time",
  "fermo_auto_non_incluso": "Not included in the total price: it varies with the actual waiting minutes.",
  "costo_passeggeri": "Passenger cost",
  "maggiorazione_weekend": "Weekend surcharge",
  "maggiorazione_notturna": "Night surcharge",
  "dettaglio_costi": "Cost breakdown",
  "gestione_pagamento": "Payment management",
  "riepilogo_e_pagamento": "Summary and payment",
  "pagamenti_e_fatture": "Payments and invoices",
  "nessun_contratto": "No contract",
  "nessuna_fattura_emessa": "No invoice issued",
  "assenza_per_tutti": "Absence for everyone",
  "assenza_per_tutti_hint": "Record an absence for every user shown (holidays, closure)",
  "nessuno_scontrino_disponibile": "No receipt available",
  "carica_scontrino": "Upload receipt photo",
  "sostituisci_scontrino": "Replace receipt photo",
  "errore_caricamento_scontrino": "Receipt upload failed",
  "caricamento_storico": "Loading history…",
  "nessuno_storico_disponibile": "No history available",
  "importo": "Amount",
  "scadenza_veicolo": "Vehicle expiration",
  "scadenza_imminente": "Imminent expiration",
  "scadenza_prossima": "Upcoming expiration",
  "revisione": "Inspection",
  "assicurazione": "Insurance",
  "omologazione": "Certification",
  "scade_oggi": "expires today",
  "scade_domani": "expires tomorrow",
  "scade_tra_giorni": "expires in {{days}} days",
  "scaduta_da_giorni": "expired {{days}} days ago",
  "veicolo": "Vehicle",
  "scadenza_label": "Expiration",
  "driver_warning": "Driver warning",
  "segnalazione": "Report",
  "nessun_commento": "No comment",
  "driver": "Driver",
  "nuovo_ordine_per": "New order for",
  "ordine_annullato_per": "Order canceled for",
  "ordine_aggiornato_per": "Order updated for",
  "previsto": "Scheduled",
  "evento": "Event",
  "ordine": "Order",
  "creato": "created",
  "unknown": "Unknown",
  "presa_visione": "Viewed",
  "evento_completato": "Event completed",
  "msg_presa_visione": "The event has been viewed",
  "msg_evento_completato": "The event has been completed",
  "posizione": "Location",
  "vedi_mappa": "See map",
  "driverVehicle": "Driver / Vehicle",
  "activityType": "Activity type",
  "departure": "Departure",
  "arrival": "Arrival",
  "nextEvent": "Next event",
  "fleetStatus": "Fleet status",
  "shift": "Shift",
  "position": "Position",
  "details": "Details",
  "Disponibile": "Available",
  "Non disponibile": "Not available",
  "-": "-",
  "Turno": "Shift",
  "Ferie": "Holiday",
  "Malattia": "Sick leave",
  "In Presidio": "On duty",
  "Fleet Status": "Fleet Status",
  "Completato da APP": "Completed via app",
  "common.tomorrow": "Tomorrow",
  "Viaggio": "Trip",
  "vicino partenza": "Near departure",
  "completato": "Completed",
  "A bordo": "On board",
  "Secondo Operatore": "Second operator",
  "privacyConsent": "To proceed: do you authorize Mbility to process your data to manage the booking and contact you by phone and email? And separately, do you also authorize the sending of commercial and promotional communications from Mbility by phone and email? You can revoke your consent at any time",
  "stationed_malpensa": "Stationed (Malpensa)",
  "permission": "Permission",
  "Assistenza Partenza": "Pick-up assistance",
  "Viaggio Car-Pooling": "Car-pooling trip",
  "mercato_b2c": "B2C Market",
  "mercato_b2c_sottotitolo": "Consumer market analysis (website, BOT, APP)",
  "carrelli_abbandonati": "Abandoned carts",
  "da_verificare": "To verify",
  "valore_totale": "Total value",
  "carrelli_abbandonati_app": "Abandoned carts APP",
  "ordini_da_sito": "Website orders",
  "ordini_da_app": "APP orders",
  "preventivi_bot": "BOT quotations",
  "ordini_web": "Web orders",
  "nessun_record_nel_periodo": "No records in the selected period",
  "nessun_record_per_i_filtri": "No records match the filters",
  "errore_apertura_viaggio": "Unable to open the trip",
  "tutti_i_canali": "All channels",
  "tutti_gli_stati": "All statuses",
  "pagati_e_non": "Paid and unpaid",
  "non_pagato": "Unpaid",
  "prezzo_medio_b2c": "B2C Average Price",
  "fatturato_b2c": "B2C Revenue",
  "numero_utenti_label": "Number of Users",
  "applica": "Apply",
  "fatturato_e_prezzo_medio_b2c": "B2C Revenue & Average Price",
  "metodi_pagamento_b2c": "B2C Payment Methods",
  "demografia_utenti_totale": "User Demographics (Total Platform)",
  "corse": "rides",
  "utenti_privati_totali": "total private users",
  "nessun_dato_disponibile": "No data available",
  "nessun_dato_filtri": "No data available for the selected filters",
  "ordini": "Orders",
  "autisti_in_turno": "Drivers on shift",
  "riempimento": "Fill rate",
  "elenco aziende": "Company list",
  "Utenti di": "Users of",
  "Aggiungi utente": "Add user",
  "no_data_available": "No data available",
  "campi_opzionali": "Optional fields",
  "assenza_ingiustificata": "Unjustified Absence",
  "geofences": "Geofences",
  "geofence_zones": "Geofence Zones",
  "zone_name": "Zone name",
  "carica_geojson": "Upload GeoJSON",
  "incolla_geojson": "Paste GeoJSON content here",
  "nessuna_zona": "No zones available",
  "zona_caricata": "Zone uploaded successfully",
  "zona_eliminata": "Zone deleted successfully",
  "errore_caricamento_zona": "Error uploading zone",
  "errore_eliminazione_zona": "Error deleting zone",
  "json_non_valido": "Invalid JSON",
  "seleziona_zona": "Select a zone to view it on the map",
  "caricamento_mappa": "Loading...",
  "elimina_zona": "Delete zone",
  "geofences_from": "Departure zones",
  "geofences_to": "Arrival zones",
  "companies_fields": "Company fields",
  "max_usages": "Maximum usages",
  "max_usages_placeholder": "Leave empty = unlimited",
  "nuovo_voucher": "New Voucher",
  "lunghezza_massima_caratteri": "Maximum characters length:",
  "errore_invio_email": "Error while sending the email",
  "planning": "Planning",
  "invia_preventivo": "Send quote",
  "preventivo_inviato": "Quote sent",
  "quotation_email": {
    "title": "Quote email",
    "send": "Send",
    "to": "To",
    "from": "From",
    "prezzo": "Price",
    "no_email": "Customer email address missing: the quote cannot be sent."
  },
  "a_capo": "Line break after field",
  "abilita_multiservizio": "Enable multi-service booking",
  "abilita_multiservizio_hint": "Allows booking several services (train, assistance, ...) within a single request.",
  "accorpa_car_pooling": "Merge car pooling",
  "aggiorna_utente": "Update user",
  "aggiungi_pausa": "Add break",
  "aggiungi_voce": "Add an item",
  "al": "To",
  "idoneita": "Eligibility",
  "operativita": "Operations",
  "criticita": "Issues",
  "esercizio": "Running costs",
  "rapporto_lavoro": "Employment",
  "inizio_rapporto": "Employment start",
  "fine_rapporto": "Employment end",
  "anagrafica": "Details",
  "annullati": "Cancelled",
  "annullati_24h": "Cancelled (24h)",
  "api_legacy": "Advanced — absolute URL (legacy)",
  "api_legacy_hint": "Use these fields only without an API Client: the backend will call the given URL directly (fallback for legacy integrations).",
  "api_parameters": "Parameters from other fields (CSV)",
  "api_parameters_hint": "Names of other fields whose values are used as call inputs (the first one becomes the trigger value).",
  "area_di_servizio": "Service area",
  "arrivalTime": "Arrival time",
  "assegnazione_singolo_viaggio": "Single trip assignment",
  "assente": "Absent",
  "assenza_split_hint": "The absence will be split into several periods.",
  "assenza_utente": "User absence",
  "assenza_viaggio": "Trip absence",
  "assenze_autisti": "Absences & special shifts",
  "assenze_totali": "Total records",
  "assenze_utente": "User absences",
  "assenze_viaggio": "Trip absences",
  "attiva": "Active",
  "attive": "Active",
  "attivi": "Active",
  "aumenta": "Increase",
  "autisti_coinvolti": "Drivers involved",
  "avvisi_autisti": "Driver warnings",
  "avvisi_totali": "Total warnings",
  "avviso": "Warning",
  "azioni_selezione": "Selection actions",
  "barr_arch_arrivo": "Barriers arr.",
  "barr_arch_partenza": "Barriers dep.",
  "calcola_tutti_prezzi": "Compute all prices",
  "cambia_gestore": "Change manager",
  "cambia_indirizzo": "Change address",
  "cambia_indirizzo_selezionati": "Change address of selected",
  "campi_extra": "Extra fields",
  "capacita_carica_non_valida": "Invalid load capacity",
  "capacita_non_valida": "Invalid capacity",
  "Capienza": "Capacity",
  "car_pooling": "Car pooling",
  "caratteristiche": "Features",
  "censiti": "Registered",
  "censito": "Registered",
  "cerca_globale": "Search drivers, vehicles, companies, users…",
  "cerca_utente": "Search user",
  "churn_anno_aperto_note": "The current year is not over yet: this figure is partial.",
  "clicca_per_visualizzare_nascondere_ordini": "Click to show or hide the orders",
  "client_api": "API client (what to call)",
  "client_api_hint": "Integration to invoke on the backend (e.g. Trenord). Leave empty to use the legacy absolute URL below.",
  "close": "Close",
  "come_vuoi_modificare_pianificato": "How do you want to edit this scheduled trip?",
  "commento": "Comment",
  "commessa_con": "With project",
  "commessa_senza": "Without project",
  "commessa_tutte": "All projects",
  "commesse": "projects",
  "con_autista": "With driver",
  "con_azienda": "With company",
  "con_email": "With email",
  "con_moduli_attivi": "With active modules",
  "con_pagamento": "With payment",
  "condizioni_paziente": "Patient conditions",
  "confirm_delete_company": "Are you sure you want to delete this company?",
  "confirm_delete_user": "Are you sure you want to delete this user?",
  "consenso_privacy": "Privacy consent",
  "contatti": "Contacts",
  "controllo_operativo": "Operations control",
  "coordinates": "Coordinates",
  "course_16h": "16h course",
  "crea_utente": "Create user",
  "da_assegnare": "To assign",
  "dal": "From",
  "data_e_orario": "Dates and times",
  "data_esecuzione": "Execution date",
  "data_inserimento": "Creation date",
  "data_non_valida": "Invalid date",
  "data_scadenza_non_valida": "Invalid expiry date",
  "data_segnalazione": "Report date",
  "data_viggio_non_valida": "Invalid trip date",
  "dati_account": "Account details",
  "dato_in_corso": "Data in progress",
  "departureTime": "Departure time",
  "descrizione_nota": "Description / note (shown under the field)",
  "descrizione_nota_hint": "Help or warning text shown to the user (e.g. under a checkbox when it is ticked).",
  "dettagli_assistenza": "Assistance details",
  "dettagli_collo": "Parcel details",
  "dettagli_servizio": "Service details",
  "dettagli_servizio_orario": "Service & schedule",
  "dettagli_viaggio_treno": "Seat and assistance",
  "diminuisci": "Decrease",
  "dimissione": "Discharge",
  "dipendenze": "Dependencies (other fields)",
  "dipendenze_hint": "The field is visible only when all the selected fields are filled in or active.",
  "disattiva": "Deactivate",
  "disattiva_gestore": "Deactivate manager",
  "disattivata": "Inactive",
  "disattivate": "Inactive",
  "disattivi": "Inactive",
  "disattivo": "Inactive",
  "distanza_gps": "GPS distance",
  "distanza_non_valida": "Invalid distance",
  "donne": "Women",
  "driver_non_valido": "Invalid driver",
  "driver_position": "Driver position",
  "durata_non_valida": "Invalid duration",
  "eccezione_per_data": "Exception by date",
  "eccezioni": "Exceptions",
  "eccezioni_per_data": "Exceptions by date",
  "elenco_assenze": "records",
  "elenco_driverwarnings": "warnings",
  "elimina_gestore": "Delete manager user",
  "equipaggiamento_sanitario": "Equipment and escort",
  "error_adding_trips": "Error while adding the trips",
  "errore_aggiornamento_utente": "Error while updating the user",
  "errore_creazione_utente": "Error while creating the user",
  "errore_eliminazione_evento": "Error while deleting the event",
  "errore_lettura_file": "Error while reading the file",
  "errore_rimozione": "Error while removing",
  "errore_rimozione_equipaggiamento": "Error while removing the equipment",
  "errori": "Errors",
  "esporta_ore_autisti": "Export driver hours",
  "esporta_xlsx": "Export XLSX",
  "esporta_presenze": "Export attendance",
  "eventi_recenti": "Recent events",
  "evento_eliminato": "Event deleted",
  "fattura_selezionati": "Invoice selected",
  "filter_function": "Filter (function)",
  "filter_function_hint": "Name of a filter function registered in the backend (e.g. trainFilter) applied to the response.",
  "filtra_gestore": "Filter by manager",
  "filtra_per_date": "Filter by date",
  "fonte_gestionale": "Back office",
  "fromVehicleToStart": "From vehicle to start",
  "genera_export": "Generate export",
  "gestione_pause": "Break management",
  "gia_tornati": "Already returned",
  "gia_tornati_short": "Returned",
  "giornaliero": "Daily",
  "giorni_pagamento": "Payment days",
  "giorni_viaggio": "Trip days",
  "giu": "Down",
  "gps_seleziona_periodo": "Select a period and press Load",
  "headers_json": "Headers (JSON)",
  "heatmap_ordini": "Orders heatmap",
  "hide_fields": "Hide these fields when the value changes",
  "hide_fields_hint": "The selected fields are hidden when this field is activated or filled in.",
  "import_completato": "Import completed",
  "importa": "Import",
  "importa_mezzi": "Import vehicles from Excel",
  "importa_viaggi": "Import trips",
  "importa_xls": "Import XLS",
  "in_attesa": "Pending",
  "indirizzo_fine": "End address",
  "indirizzo_inizio": "Start address",
  "indirizzo_non_valido": "Invalid address",
  "integration_desc_trenord": "Lets the train fields (train number, network) query the Trenord APIs for train status and timetable search.",
  "integrazione_api": "API integration",
  "integrazione_api_hint": "Connects the field to an external service through the backend resolver: on value change it calls the API and fills other fields with the response.",
  "json_invalido": "Invalid JSON",
  "kb": "KB",
  "lascia_vuoto_per_non_modificare": "Leave a field empty to keep it unchanged.",
  "last_update": "Last update",
  "logica_campo_campo": "Field → field logic",
  "logica_campo_campo_hint": "Automations between fields of the same form: when this field changes you can update or hide others.",
  "luogo_assistenza": "Assistance location",
  "metodo_http": "HTTP method",
  "modalita": "Mode",
  "modalita_fatturazione": "Billing mode",
  "mode_api": "API (external software)",
  "mode_api_desc": "Orders are handled by the partner's external software, which updates their status via webhook. No manual entry in the back office.",
  "mode_hybrid": "Hybrid",
  "mode_hybrid_desc": "Orders come from the external software but can also be handled manually by operators.",
  "mode_portal": "Portal (manual)",
  "mode_portal_desc": "Orders are handled manually by operators in the back office. No automatic sync with external systems.",
  "Modello": "Model",
  "modifica_assenza": "Edit absence or shift",
  "modifica_avviso": "Edit warning",
  "modifica_campo": "Edit field",
  "modifica_gestore": "Edit manager",
  "modifica_pianificato": "Edit scheduled trip",
  "modifica_utente": "Edit user",
  "moduli_attivi": "Active modules",
  "mostra_altri": "Show more",
  "mostra_annullati": "Show cancelled",
  "motivo": "Reason",
  "nascondi_annullati": "Hide cancelled",
  "nascosto": "Hidden",
  "nel": "in",
  "nessun_annullato": "No cancellation",
  "nessun_avviso": "No warning",
  "nessun_cliente": "No client",
  "nessun_equipaggiamento": "No equipment assigned",
  "nessun_indirizzo": "No address",
  "nessun_mezzo_nel_file": "No vehicle found in the file",
  "nessun_modulo": "None",
  "nessun_nuovo_viaggio": "No new trip",
  "nessun_ordine": "No order",
  "nessun_ordine_filtri": "No order found for the selected filters.",
  "nessun_pianificato": "No planned trip",
  "nessun_risultato": "No result",
  "nessun_utente_azienda": "No user for this company",
  "nessun_utente_cdi": "No user found for this day care centre",
  "nessun_utente_gestore_msg": "No manager user assigned to this manager.",
  "nessun_viaggio": "No trip",
  "nessun_viaggio_filtri": "No active trip for the selected filters.",
  "nessun_viaggio_pianificato": "No scheduled trip",
  "nessun_viaggio_selezionato": "No trip selected",
  "nessun_viaggio_trovato": "No trip found for the selected filters.",
  "nessuna_assenza": "No absence",
  "nessuna_assenza_periodo": "No absence found for the selected period",
  "nessuna_corsa": "No daily run",
  "nessuna_modifica": "No change to save",
  "nessuna_pausa_definita": "No break defined",
  "nome_univoco": "Unique name (e.g. badge_id)",
  "non_ancora_tornati": "Not returned yet",
  "normali": "Normal",
  "notifiche_email": "Email notifications",
  "numero_civico": "Street number",
  "nuova_assenza": "New absence or special shift",
  "nuovi_viaggi_24h": "New trips (24h)",
  "nuovo_account": "New account",
  "nuovo_avviso": "New warning",
  "nuovo_campo": "New field",
  "nuovo_gruppo": "New group",
  "nuovo_pianificato": "New scheduled trip",
  "nuovo_viaggio_pianificato": "New scheduled trip",
  "on_change_update": "Update these fields when the value changes",
  "on_change_update_hint": "When this field changes, the selected fields are filled with the derived data (e.g. from the response extras).",
  "operativo": "Operational",
  "opzioni_select": "Select options",
  "ora": "Hour",
  "ora_fine": "End time",
  "ora_inizio": "Start time",
  "ora_non_valida": "Invalid time",
  "ordini_app": "App orders",
  "ordini_bot": "Bot orders",
  "ordini_selezionati": "selected order(s)",
  "ordini_sito": "Website orders",
  "ownership_leasing": "Leasing",
  "ownership_owned": "Owned",
  "ownership_rental": "Rental",
  "panoramica_operativa": "Operations overview",
  "param_map": "Parameter map (JSON) — multi-input",
  "param_map_hint": "For calls with several inputs (e.g. timetable engine): map each API parameter to the form field it takes its value from. Best used with a Button field.",
  "params_json": "Static params (JSON)",
  "per_referrer": "By referrer",
  "per_sempre_modifica_pianificato": "Forever (edit scheduled trip)",
  "per_sesso": "By gender",
  "periodo": "Period",
  "persi": "Lost",
  "pianifica_viaggi_settimana": "Add one or more trips for each day",
  "pianificati_attivi": "Scheduled",
  "pianificato": "Scheduled",
  "populate": "Fields to fill with the response",
  "populate_hint": "Fields filled (options or value) with the response data, according to the response mapper.",
  "posizione_hint": "Display order within the section: lower numbers appear first. Empty = last.",
  "posizione_live": "Live position",
  "punto_scambio": "Exchange point",
  "quando": "When",
  "query_param": "Query param (e.g. dep_time)",
  "query_param_hint": "Name of the querystring parameter used to send the field value with the call.",
  "response_mapper": "Response mapper (JSON)",
  "response_mapper_hint": "Describes how to read the API response in order to fill the linked fields.",
  "response_mapper_json_invalido": "The response_mapper is not valid JSON.",
  "riattiva": "Reactivate",
  "riattiva_gestore": "Reactivate manager",
  "ricerca_in_corso": "Searching…",
  "richiedente": "Requester",
  "rimozione_riuscita": "Removed successfully",
  "cerca_passeggero_indirizzo_azienda": "Passenger, address, company…",
  "rimuovi_filtri": "Clear filters",
  "rimuovi_pausa": "Remove break",
  "rimuovi_viaggio_dal_gruppo": "Remove this trip from the group?",
  "ripristina_questa_corsa": "Restore this run",
  "riprova": "Retry",
  "salvataggio": "Saving…",
  "Scadenza": "Expiry",
  "scadenze_da_gestire": "Deadlines to handle",
  "scaduto": "Expired",
  "segnali_operativi": "Operational signals",
  "seleziona_campi": "Select fields...",
  "seleziona_centro_diurno_desc": "Pick a centre from the menu above to view and manage the trips of the week.",
  "seleziona_centro_diurno_hint": "Select a day care centre to continue.",
  "seleziona_centro_diurno_titolo": "Select a day care centre",
  "seleziona_client": "Select client...",
  "seleziona_data": "Select date",
  "seleziona_dipendenze": "Select dependencies...",
  "seleziona_file_tracciato": "Select a track file for the preview",
  "seleziona_fine": "Select the end date",
  "seleziona_hub": "Select hub",
  "seleziona_inizio": "Select the start date",
  "seleziona_servizi": "Select services...",
  "seleziona_zone": "Select zones...",
  "selezionati": "selected",
  "selezionato": "selected",
  "selezione_multipla": "Allow multiple selection",
  "senza_pagamento": "Without payment",
  "sequenza_tappe": "Stop sequence",
  "servizio_multiservizio": "Services (multi-service)",
  "servizio_multiservizio_hint": "In multi-service bookings, links the field to one or more services (train/assistance/...). Each service becomes a separate order; a field on several services is duplicated in each order. Empty = shared field, included in every order.",
  "settimana_precedente": "Previous week",
  "settimana_successiva": "Next week",
  "sezione": "Section",
  "sezione_form": "Trip form section",
  "sezione_in_arrivo": "Section coming soon",
  "sicuro_disattiva_gestore": "The manager will no longer be selectable for new services (e.g. in bookings). Continue?",
  "sicuro_rimuovi_cliente": "Are you sure you want to delete this client?",
  "sicuro_rimuovi_equipaggiamento": "Are you sure you want to remove this equipment?",
  "sicuro_rimuovi_gestore": "Are you sure you want to delete this manager user?",
  "sicuro_rimuovi_hub": "Are you sure you want to remove this hub?",
  "sito_web": "Website",
  "sola_lettura": "Read only",
  "solo_preprod": "Pre-production only (test)",
  "sosta": "Stop",
  "sosta_min_sec": "Min stop (s)",
  "spostamento_max_m": "Max movement (m)",
  "step": "Step",
  "su": "Up",
  "surname": "Surname",
  "switch_group_hint": "Required/Read only/Hidden control input and visibility. “Line break” forces a new row in the grid. “Pre-production only” shows the field to admins only (testing), hiding it from end users.",
  "tasso_abbandono_b2c": "B2C churn rate",
  "tempo_ritorno": "Return time",
  "tipo_avviso": "Warning type",
  "tipo_campo": "Field type",
  "tipo_non_valido": "Invalid type",
  "tipologia_servizio": "Service type",
  "totale_scadenze": "Total deadlines",
  "trasporto_oggetti": "Object transport",
  "tratta_stazioni": "Station route",
  "trattenuti": "Retained",
  "trigger_api": "Call API when the value changes",
  "trigger_on_change_update": "Conditions enabling the update",
  "trigger_on_change_update_hint": "The update above happens only if these fields are active or filled in. Empty = always.",
  "trips_added_successfully": "Trips added successfully",
  "tutti_autisti": "All drivers",
  "tutti_i_gestori": "All managers",
  "tutti_i_viaggi": "All trips",
  "tutto_ok": "All good",
  "tyre_all_season": "All season",
  "tyre_summer": "Summer",
  "tyre_winter": "Winter",
  "ultima_settimana": "Last week",
  "ultimi_30_giorni": "Last 30 days",
  "uomini": "Men",
  "utente_aggiornato": "User updated",
  "utente_creato": "User created",
  "utente_non_valido": "Invalid user.",
  "valore_default": "Default value",
  "valore_perso": "Lost value",
  "validator_function": "Validator (function)",
  "validator_function_hint": "Name of a backend validation function (e.g. trainDate): if it fails a warning is shown to the user.",
  "vedi_tutti": "View all",
  "vedi_tutti_n_one": "View all ({{count}})",
  "vedi_tutti_n_other": "View all ({{count}})",
  "vehicle": "Vehicle",
  "veicolo_non_valido": "Invalid vehicle",
  "viaggi_di_oggi": "Today's trips",
  "viaggi_eseguiti": "Completed trips",
  "viaggi_visibili": "Visible trips",
  "viaggio_pianificato": "Scheduled trip",
  "visualizza_gruppo": "View group",
  "vista": "View",
  "vista_carte": "Cards",
  "vista_compatta": "Compact view",
  "vista_estesa": "Expanded view",
  "vista_tabella": "Table",
  "vuoi_cancellare_definitavamente_ordine": "Do you want to permanently delete this order?",
  "vuoi_cancellare_evento": "Do you want to delete this event?",
  "wheelchair_lift": "Wheelchair lift",
  "wheelchair_seats": "Wheelchair seats",
  "common": {
    "tomorrow": "Tomorrow"
  },
  "planner": {
    "subtitle": "Plan and assign recurring trips"
  },
  "assenze": "Absences",
  "eta_arrivo": "Arrival ETA",
  "invia_email_pagamento": "Send payment email",
  "n_fatture": "No. of invoices",
  "other": "Other",
  "passeggero_dest": "Passenger / Destination",
  "soccorso": "rescue",
  "Inserito": "Created",
  "Assegnato": "Assigned",
  "Pagato": "Paid",
  "Vicino Partenza": "Near departure",
  "Completato": "Completed",
  "Annullato": "Cancelled",
  "Vicino Arrivo": "Near arrival",
  "Non Presentato": "No show",
  "Annullato (24h)": "Cancelled (24h)",
  "Rifiutato": "Rejected",
  "Assente": "Absent",
  "tipo_hub": "Hub type",
  "hub_type_depot": "Depot",
  "hub_type_station": "Station",
  "hub_type_stop": "Stop",
  "hub_type_parking": "Parking",
  "hub_type_charging": "Charging point",
  "localizzazione": "Location",
  "latitudine": "Latitude",
  "longitudine": "Longitude",
  "latitudine_non_valida": "Invalid latitude",
  "longitudine_non_valida": "Invalid longitude",
  "fuori_intervallo": "out of range",
  "avanti": "Next",
  "importa_hub": "Import hubs / stations",
  "stazione": "Station",
  "cerca_stazione": "Search a station…",
  "import_seleziona_file": "Select a JSON, Excel or CSV file",
  "import_nessun_file": "No file selected",
  "import_nessuna_riga": "No rows found in the file",
  "import_json_non_valido": "Invalid JSON",
  "import_struttura_non_valida": "The file does not contain a list of records",
  "import_foglio": "Sheet",
  "import_ignora": "— Ignore —",
  "import_valore_fisso": "Fixed value…",
  "import_righe_lette": "{{count}} rows read from the file",
  "import_riepilogo": "{{valid}} valid rows, {{invalid}} discarded",
  "import_righe_scartate": "Discarded rows",
  "import_riga": "Row",
  "import_altre_righe": "… and {{count}} more",
  "import_esito": "{{created}} created, {{updated}} updated, {{skipped}} skipped",
  "import_errore_numero": "invalid numeric value",
  "import_errore_obbligatorio": "required",
  "import_tipo_non_valido": "unknown type",
  "opzioni_stazione": "Station search",
  "station_input_hint": "The field searches hubs of this type and stores the selected station (code, city and coordinates) on the booking.",
  "email_config_title": "Email flow",
  "email_config_enabled": "Email sending active",
  "email_config_enabled_hint": "Emails follow the configuration below. An event switched off upstream (manager or company) stays off even if enabled here.",
  "email_config_disabled_hint": "No email will be sent. Blocked sends are still recorded in the Communications tab with the reason.",
  "email_config_sender": "Sender and recipients",
  "email_config_sender_name": "Sender name",
  "email_config_sender_email": "Sender email",
  "email_config_reply_to": "Reply to",
  "email_config_copies": "Copies on every email",
  "email_config_cc": "CC",
  "email_config_bcc": "BCC",
  "email_config_addresses_hint": "Multiple addresses separated by commas.",
  "email_config_events": "Events",
  "email_config_template": "Brevo template",
  "email_config_template_default": "Default",
  "email_config_recipients_override": "Recipients (replaces)",
  "email_event_trip_quote_summary": "Quote and payment",
  "email_event_trip_quote_summary_desc": "Trip summary with payment and confirmation links.",
  "email_event_quotation_sent": "Quotation",
  "email_event_quotation_sent_desc": "Quotation sent to the customer.",
  "email_event_booking_confirmation_flexymob": "FlexyMob booking confirmation",
  "email_event_booking_confirmation_flexymob_desc": "Confirmation sent for bookings coming from FlexyMob.",
  "email_event_order_einvoice": "E-invoice",
  "email_event_order_einvoice_desc": "Sent when the invoice is accepted by SDI, with the PDF attached.",
  "email_event_trip_created": "Trip created",
  "email_event_trip_created_desc": "Notifies the customer when the trip is created.",
  "email_event_trip_confirmed": "Trip confirmed",
  "email_event_trip_confirmed_desc": "Notifies the customer when the trip becomes confirmed.",
  "email_event_trip_updated": "Trip updated",
  "email_event_trip_updated_desc": "Sent when pickup, destination or date change.",
  "email_event_trip_canceled": "Trip cancelled",
  "email_event_trip_canceled_desc": "Notifies the customer of a cancellation.",
  "email_event_trip_completed": "Trip completed",
  "email_event_trip_completed_desc": "Notifies the customer once the trip is over.",
  "email_event_trip_reminder_24h": "24-hour reminder",
  "email_event_trip_reminder_24h_desc": "Reminder sent the day before the trip.",
  "email_event_trip_reminder_1h": "1-hour reminder",
  "email_event_trip_reminder_1h_desc": "Reminder sent one hour before the trip.",
  "email_event_manual_trips_summary": "Manual trips summary",
  "email_event_manual_trips_summary_desc": "Trips summary sent by hand by an operator.",
  "email_event_trenord_booking_created": "Trenord — assistance confirmed",
  "email_event_trenord_booking_created_desc": "Confirmation of the assistance request, with stations and times.",
  "email_event_trenord_booking_canceled": "Trenord — assistance cancelled",
  "email_event_trenord_booking_canceled_desc": "Cancellation of the assistance request.",
  "email_event_quotation_abandoned": "Abandoned quotation",
  "email_event_quotation_abandoned_desc": "Recovers website quotations left without a booking.",
  "email_event_manager_assistance_request": "PRM assistance request",
  "email_event_manager_assistance_request_desc": "New assistance to carry out, with station, date and disability type.",
  "email_event_manager_trip_assigned": "New trip to handle",
  "email_event_manager_trip_assigned_desc": "Notifies the manager, with accept and refuse links.",
  "email_event_manager_trip_decision_confirm": "Accept/refuse confirmation",
  "email_event_manager_trip_decision_confirm_desc": "Summary sent to the manager after their decision.",
  "email_event_manager_trip_canceled": "Trip cancelled",
  "email_event_manager_trip_canceled_desc": "Notifies the manager when the customer cancels.",
  "email_event_company_planned_trip_approved": "Planned trip confirmed",
  "email_event_company_planned_trip_approved_desc": "Notifies the company when a recurring trip is confirmed.",
  "email_event_company_trips_summary": "Trips summary",
  "email_event_company_trips_summary_desc": "Periodic summary of the company trips.",
  "email_event_company_users_trips_summary": "Trips summary by user",
  "email_event_company_users_trips_summary_desc": "Periodic summary of trips grouped by user.",
  "email_event_internal_pending_request": "Recurring trip request",
  "email_event_internal_pending_request_desc": "Internal notice of a new request.",
  "email_event_internal_job_alert": "Unhandled trips alert",
  "email_event_internal_job_alert_desc": "Internal notice of trips left unhandled.",
  "telefono_principale": "Main phone",
  "telefono_aziendale": "Company phone",
  "telefono_privato": "Personal phone",
  "indirizzo_residenza": "Residence address",
  "indirizzo_domicilio": "Domicile address",
  "domicilio_uguale_residenza": "Domicile same as residence",
  "durata_ore": "Duration (hours)",
  "tipologie_dotazione": "Equipment types",
  "nuovo_tipo_dotazione": "New equipment type",
  "modifica_tipo_dotazione": "Edit equipment type",
  "nessun_tipo_dotazione": "No type",
  "nessun_tipo_dotazione_desc": "Create the equipment types (fire extinguisher, lift, backup keys…): each one can declare its own fields.",
  "nessun_tipo_dotazione_hint": "No type defined yet: create them in the \"Equipment types\" tab.",
  "sicuro_rimuovi_tipo_dotazione": "Delete this type? Existing equipment keeps it, but it will no longer be selectable.",
  "nome_tipo_dotazione_placeholder": "e.g. Lift, Backup keys",
  "seleziona_tipologia": "Select a type",
  "tipo_obbligatorio": "Select a type",
  "campi_standard": "Standard fields",
  "opzioni_separate_virgola": "Options (comma separated)",
  "e_una_scadenza": "Is a deadline",
  "campo_testo": "Text",
  "campo_data": "Date",
  "campo_numero": "Number",
  "campo_scelta": "Choice",
  "slug": "Technical slug",
  "icona": "Icon (Font Awesome name)",
  "scadenza_corso_autista": "Driver course expired",
  "corsi_certificazioni": "Courses & certifications",
  "nessun_corso": "No course recorded",
  "aggiungi_corso": "Add course",
  "nuovo_corso": "New course or certification",
  "modifica_corso": "Edit course",
  "sicuro_rimuovi_corso": "Delete this course?",
  "nome_corso": "Course name",
  "categorie_patente": "Categories",
  "ente_rilasciante": "Issuing body",
  "data_conseguimento": "Issue date",
  "data_rinnovo": "Last renewal date",
  "deadline_cat_driver_course": "Driver course",
  "mezzo_autista": "Vehicle / Driver",
  "driver_course_patente": "Driving licence",
  "driver_course_cqc": "CQC",
  "driver_course_carta_tachigrafica": "Tachograph card",
  "driver_course_corso_16h": "16-hour course",
  "driver_course_kb": "KB",
  "driver_course_blsd": "BLSD",
  "driver_course_primo_soccorso": "First aid",
  "driver_course_antincendio": "Fire safety",
  "driver_course_haccp": "HACCP",
  "driver_course_dpi": "PPE",
  "driver_course_formazione_generale": "General safety training",
  "driver_course_formazione_specifica": "Specific safety training",
  "driver_course_altro": "Other",
  "carrozzine_supportate": "Supported wheelchairs",
  "carrozzina_pieghevole": "Foldable",
  "carrozzina_rigida": "Rigid",
  "carrozzina_motorizzata": "Powered",
  "carrozzina_altro": "Other",
  "posti_carrozzina_disallineati": "Declared wheelchair spaces ({{declared}}) do not match the layout ({{layout}}).",
  "date_contratto": "Contract dates",
  "scadenze_documentali": "Document deadlines",
  "gestore_non_accessibile": "Vehicle manager not accessible",
  "gestore_non_accessibile_desc": "The manager linked to this vehicle is not visible with your profile, or the vehicle has no manager assigned.",
  "gps_caricamento_gestore": "Loading the manager configuration.",
  "errore_caricamento_gps": "Error loading GPS data",
  "nome_gia_esistente": "An item with this name already exists in this folder",
  "spostamento_in_corso": "Moving",
  "maintenance_insurance": "Insurance",
  "maintenance_homologation": "Homologation",
  "maintenance_ownership": "Ownership expiry",
  "maintenance_road_tax": "Road tax",
  "bollo": "Road tax",
  "maintenance_registration": "Registration",
  "data_emissione": "Issue date",
  "data_scadenza": "Expiry date",
  "documento_sync_hint": "The expiry date updates the document on the vehicle record and feeds the deadline board and notifications.",
  "da_registrare": "To be recorded",
  "registra_intervento": "Record intervention",
  "operazione_in_corso": "Operation in progress",
  "pagina_non_trovata": "Page not found",
  "pagina_non_trovata_msg": "The requested path does not exist or is no longer available.",
  "torna_alla_home": "Back to home",
  "nuova_dotazione": "New equipment",
  "codice_obbligatorio": "Code is required",
  "documenti_gestore": "Manager documents",
  "documenti_azienda": "Company documents",
  "documenti_cliente": "Client documents",
  "danni": "Damages",
  "vehicle_damage": "Vehicle damage",
  "segnala_danno": "Report damage",
  "modifica_danno": "Edit report",
  "nessun_danno": "No damage reported",
  "sicuro_rimuovi_danno": "Delete this damage report?",
  "dettagli_danno": "Damage details",
  "area_danno": "Area",
  "seleziona_area": "Select area",
  "area_obbligatoria": "Select the area",
  "titolo_obbligatorio": "Title is required",
  "titolo": "Title",
  "componente": "Component",
  "gravita": "Severity",
  "mezzo_non_utilizzabile": "{{count}} open blocking damage: the vehicle must not be used.",
  "mezzo_non_utilizzabile_plural": "{{count}} open blocking damages: the vehicle must not be used.",
  "damage_area_bodywork": "Bodywork",
  "damage_area_scratches": "Scratches",
  "damage_area_dents": "Dents",
  "damage_area_glass": "Glass and mirrors",
  "damage_area_interior": "Interior and passenger compartment",
  "damage_area_seats_upholstery": "Seats and upholstery",
  "damage_area_flooring": "Flooring",
  "damage_area_ramp_lift": "Ramp / lift",
  "damage_area_accessories": "Accessories",
  "damage_area_worn_components": "Worn components",
  "damage_area_other": "Other",
  "damage_severity_low": "Low",
  "damage_severity_medium": "Medium",
  "damage_severity_high": "High",
  "damage_severity_blocking": "Blocking",
  "damage_status_reported": "Reported",
  "damage_status_in_progress": "In progress",
  "damage_status_resolved": "Resolved",
  "damage_status_dismissed": "Dismissed",
  "driver_status_active": "Active",
  "driver_status_training": "In training",
  "driver_status_resigning": "Resigning",
  "driver_status_inactive": "Inactive",
  "driver_status_assignable": "Operational",
  "stato_autista": "Driver status",
  "mostra_inattivi": "Show inactive",
  "contratto_terminato_hint": "Contract ended on {{date}} — consider status \"Inactive\"",
  "stato_non_valido": "Invalid status",
  "nascondi_inattivi": "Hide inactive",
  "vehicle_status_decommissioned": "Decommissioned",
  "vehicle_status_sold": "Sold",
  "mezzi_in_flotta": "In fleet",
  "mezzi_operativi": "Operational",
  "mezzi_fermi": "Out of service",
  "violation_type_multa": "Fine",
  "violation_type_sinistro": "Accident",
  "violation_status_pending": "To pay",
  "violation_status_contested": "Appealed",
  "violation_status_charged": "Charged to driver",
  "violation_status_paid": "Paid",
  "violation_status_written_off": "Written off",
  "violation_status_open": "Open",
  "violation_responsibility_unknown": "Unassigned",
  "violation_responsibility_driver": "Driver",
  "violation_responsibility_company": "Company",
  "violation_responsibility_third_party": "Third party",
  "multe_e_sinistri": "Fines and accidents",
  "verbale": "Notice",
  "verbali": "Notices",
  "nuovo_verbale": "New notice",
  "modifica_verbale": "Edit notice",
  "sicuro_rimuovi_multa": "Delete this notice?",
  "nessuna_multa": "No notices",
  "nessuna_multa_autista": "No notices assigned to this driver",
  "multe_scadute": "{{count}} notices past their payment deadline.",
  "dati_verbale": "Notice details",
  "numero_verbale": "Notice number",
  "data_infrazione": "Offence date",
  "data_notifica": "Notification date",
  "ente_accertatore": "Issuing authority",
  "importi_e_stato": "Amounts and status",
  "importo_ridotto": "Discounted amount (€)",
  "scadenza_pagamento": "Payment deadline",
  "data_pagamento": "Payment date",
  "punti_decurtati": "Licence points",
  "responsabilita": "Responsibility",
  "a_carico_di": "Charged to",
  "a_carico_autista": "Charged to driver",
  "ricorsi": "Appeals",
  "scadute": "Overdue",
  "scaduta": "Overdue",
  "da_pagare": "To pay",
  "pagata": "Paid",
  "residuo": "Outstanding",
  "gia_versato": "Already paid",
  "rivalsa_autista": "Driver repayment",
  "rivalsa_senza_autista": "A repayment plan only applies to fines charged to the driver",
  "piano_rientro": "Repayment plan",
  "anteprima_piano": "Plan preview",
  "numero_rate": "Instalments",
  "prima_rata": "First instalment",
  "cadenza_mesi": "Interval (months)",
  "rate_non_valide": "Invalid number of instalments",
  "rate_pagate": "{{paid}} of {{total}} instalments",
  "rata": "Instalment",
  "segna_pagata": "Mark as paid",
  "segna_non_pagata": "Mark as unpaid",
  "apri_autista": "Open driver",
  "damage_status_open": "Open",
  "rilievo_fotografico": "Photo survey",
  "sezioni_coperte": "{{done}}/{{total}} required sections",
  "foto_danno": "Damage photos",
  "foto_danno_presenti": "{{count}} photos",
  "foto_danno_richiesta": "At least one photo of the damage is required",
  "censimento_non_configurato": "\"Vehicle inspection\" process type not configured",
  "censimento_del": "Inspection of",
  "nessun_danno_rilevato": "No damages found",
  "modifiche_rispetto_precedente": "What changed since the previous inspection",
  "censimento_ora": "Now",
  "voce": "Item",
  "censimento_prima": "Before",
  "aggiungi_foto": "Add photo",
  "foto_mancante": "Photo missing",
  "apri_foto": "Open photo",
  "ora_puoi_allegare_foto": "Report created: you can now attach photos.",
  "photo_section_body_front": "Front",
  "photo_section_body_rear": "Rear",
  "photo_section_body_left": "Left side",
  "photo_section_body_right": "Right side",
  "photo_section_passenger_compartment": "Passenger compartment and interior",
  "photo_section_seats": "Seats",
  "photo_section_flooring": "Flooring",
  "photo_section_ramp_lift": "Ramp / lift",
  "photo_section_damage_detail": "Damage photos",
  "apri_mezzo": "Open vehicle",
  "mezzi_bloccati": "{{count}} vehicle with an open blocking damage.",
  "mezzi_bloccati_plural": "{{count}} vehicles with an open blocking damage.",
  "vehicle_maintenance_process": "Maintenance in progress",
  "process_status_open": "Open",
  "process_status_closed": "Closed",
  "process_status_cancelled": "Cancelled",
  "campo_testo_lungo": "Long text",
  "campo_check": "Yes / No",
  "errore_upload_foto": "Photo upload failed",
  "upload_in_corso": "Uploading…",
  "pratiche": "Practices",
  "tipi_pratica": "Practice types",
  "nuovo_tipo_pratica": "New practice type",
  "modifica_tipo_pratica": "Edit practice type",
  "nessun_tipo_pratica": "Configure a practice type first.",
  "nessun_tipo_pratica_hint": "Start from the default pipelines (vehicle maintenance, driver hiring) and adapt them.",
  "carica_pipeline_predefinite": "Load default pipelines",
  "sicuro_rimuovi_tipo_pratica": "Delete this practice type? Open practices remain but can no longer be advanced.",
  "stage_pratica": "Practice stages",
  "campi_pratica": "Fields for the whole practice",
  "aggiungi_stage": "Add stage",
  "nuovo_stage": "New stage",
  "stage_finale": "Final",
  "stage_annullamento": "Cancellation",
  "stage_chiude_pratica": "This stage closes the practice",
  "stage_esito_positivo": "Successful outcome (otherwise: cancelled)",
  "anteprima_percorso": "Path preview",
  "percorso_stage": "Path",
  "entita_riferimento": "Related entity",
  "process_subject_vehicle": "Vehicle",
  "process_subject_driver": "Driver",
  "process_subject_company": "Company",
  "process_subject_none": "None",
  "nessun_campo_stage": "No field required at this stage.",
  "sposta_su": "Move up",
  "sposta_giu": "Move down",
  "avanza_pratica": "Advance",
  "storico_pratica": "Stage history",
  "pratica_chiusa": "Practice closed.",
  "nessuna_pratica": "No open practice",
  "pratiche_aperte": "Open practices",
  "apri_pratica": "Open practice",
  "nuova_pratica": "New practice",
  "tipo_pratica_obbligatorio": "Select the practice type",
  "soggetto_obbligatorio": "Select the subject",
  "gestisci_pratica": "Manage practice",
  "pratica_aperta": "Practice opened",
  "sicuro_rimuovi_pratica": "Delete this practice?",
  "priorita": "Priority",
  "origine": "Origin",
  "aperta_da": "Open for",
  "cruscotto": "Board",
  "pipeline_manutenzione_assente": "No maintenance pipeline configured: load it from the practice types to manage work step by step.",
  "process_priority_low": "Low",
  "process_priority_normal": "Normal",
  "process_priority_high": "High",
  "process_priority_urgent": "Urgent",
  "process_origin_damage": "Damage",
  "process_origin_deadline": "Deadline",
  "process_origin_manual": "Manual",
  "manutenzione_da_danno": "Maintenance from damage report",
  "rifornimenti": "Refuelings",
  "nuovo_rifornimento": "New refueling",
  "modifica_rifornimento": "Edit refueling",
  "nessun_rifornimento": "No refueling",
  "sicuro_rimuovi_rifornimento": "Delete this refueling?",
  "dati_rifornimento": "Refueling details",
  "vehicle_refuel": "Refueling",
  "vehicle_inspection": "Vehicle inspection",
  "censimento": "Inspection",
  "censimenti": "Inspections",
  "censimento_mezzo": "Vehicle inspection",
  "nuovo_censimento": "New inspection",
  "riprendi_censimento": "Resume inspection",
  "chiudi_censimento": "Close inspection",
  "nessun_censimento": "No inspection",
  "sicuro_rimuovi_censimento": "Delete this inspection?",
  "censimento_in_bozza": "There is already a draft inspection to complete.",
  "inizia_dal_punto_zero": "The first inspection is the baseline every monthly check is compared against.",
  "ultimo_censimento": "Last inspection",
  "mai_censito": "Never inspected",
  "da_censire": "To inspect",
  "giorni_fa": "{{count}} days ago",
  "mezzi_da_censire": "{{count}} vehicles with no inspection in the last 30 days.",
  "mezzi_da_censire_titolo": "Vehicles to inspect",
  "flotta_censita": "Every vehicle was inspected in the last month",
  "rilevazioni": "surveys",
  "sintesi_stato_veicolo": "Vehicle state summary",
  "scadenze_documenti": "Deadlines, maintenance and documents",
  "pneumatici": "Tyres",
  "pneumatico": "Tyre",
  "allestimento_sicurezza": "Equipment, safety and accessories",
  "danni_e_interventi": "Damages and interventions found",
  "chiusura_rilevazione": "Closing the survey",
  "data_e_ora_censimento": "Inspection date and time",
  "rilevatore": "Surveyor",
  "km_rilevati": "Odometer",
  "veicolo_funzionante": "Vehicle operational",
  "idoneo_al_servizio": "Fit for service",
  "stato_generale": "General condition",
  "pulizia_interna": "Interior cleanliness",
  "note_sintetiche": "Summary notes",
  "stato_usura": "Wear",
  "da_sostituire": "To replace",
  "intervento_necessario": "Intervention needed",
  "interventi_da_aprire": "Interventions needed",
  "nessun_intervento_necessario": "No intervention needed",
  "danni_rilevati": "Damages found in this inspection",
  "esito_finale": "Final outcome",
  "esito_suggerito": "Suggested from what was filled in:",
  "esito_obbligatorio": "Select the final outcome",
  "sezioni_incomplete": "Sections still incomplete: {{list}}",
  "interventi_urgenti": "Urgent interventions",
  "voci_compilate": "{{done}}/{{total}} items filled in",
  "confronto_con_precedente": "Compared with the {{kind}} of {{date}}",
  "primo_censimento": "Baseline: there is no previous inspection",
  "nessuna_variazione": "No change since the previous inspection",
  "nuovi_danni": "New damages",
  "nuovi_interventi": "New interventions",
  "interventi_chiusi": "Closed interventions",
  "km_percorsi": "Km driven",
  "compilazione": "Filled in",
  "bozza": "Draft",
  "chiusi": "Closed",
  "trend_improved": "Improved",
  "trend_worsened": "Worsened",
  "trend_same": "Changed",
  "inspection_section_summary": "Summary",
  "inspection_section_tyres": "Tyres",
  "inspection_section_equipment": "Equipment",
  "inspection_field_general_condition": "General condition",
  "inspection_field_operational": "Vehicle operational",
  "inspection_field_fit_for_service": "Fit for service",
  "inspection_field_cleanliness": "Interior cleanliness",
  "inspection_kind_zero": "Baseline",
  "inspection_kind_monthly": "Monthly check",
  "inspection_outcome_compliant": "Compliant",
  "inspection_outcome_usable_with_works": "Usable with interventions",
  "inspection_outcome_not_usable": "Not usable",
  "operational_state_yes": "Yes",
  "operational_state_limited": "With limitations",
  "operational_state_no": "No",
  "fitness_state_yes": "Yes",
  "fitness_state_to_verify": "To verify",
  "fitness_state_no": "No",
  "condition_state_good": "Good",
  "condition_state_fair": "Fair",
  "condition_state_poor": "Poor",
  "condition_state_critical": "Critical",
  "cleanliness_state_compliant": "Compliant",
  "cleanliness_state_to_improve": "To improve",
  "cleanliness_state_non_compliant": "Non compliant",
  "tyre_position_front_left": "Front left",
  "tyre_position_front_right": "Front right",
  "tyre_position_rear_left": "Rear left",
  "tyre_position_rear_right": "Rear right",
  "wear_state_good": "Good",
  "wear_state_medium": "Medium",
  "wear_state_critical": "Critical",
  "intervention_urgency_no": "No",
  "intervention_urgency_yes": "Yes",
  "intervention_urgency_urgent": "Urgent",
  "equipment_item_ramp_lift": "Ramp / lift",
  "equipment_item_wheelchair_retractors": "Retractors / wheelchair restraints",
  "equipment_item_belts": "Belts / restraint systems",
  "equipment_item_seats": "Seats and upholstery",
  "equipment_item_flooring": "Flooring",
  "equipment_item_doors": "Doors / locks",
  "equipment_item_glass": "Glass / mirrors",
  "equipment_item_livery": "Livery / logos / signage",
  "equipment_item_onboard_kit": "On-board kit",
  "equipment_item_other": "Other",
  "equipment_state_ok": "OK",
  "equipment_state_worn": "Worn",
  "equipment_state_broken": "Broken",
  "quantita": "Quantity",
  "prezzo_unitario": "Unit price",
  "distributore": "Station",
  "codice_tessera": "Card code",
  "consumo": "Consumption",
  "spesa": "Spend",
  "mezzo_obbligatorio": "Select the vehicle",
  "quantita_obbligatoria": "Enter a valid quantity",
  "importo_obbligatorio": "Enter a valid amount",
  "refueling_provider_dkv": "DKV",
  "refueling_provider_atlante": "Atlante",
  "refueling_provider_hub": "Hub",
  "refueling_provider_manual": "Manual",
  "refueling_type_fuel": "Fuel",
  "refueling_type_electric": "Electric charging",
  "refueling_type_adblue": "AdBlue",
  "importa_rifornimenti": "Import refuelings",
  "importa_per_iniziare": "Upload a monthly provider export to populate the data.",
  "costo_km": "Cost / km",
  "id_transazione": "Transaction ID",
  "gestore_mancante": "Manager could not be determined",
  "nessun_mezzo_per_import": "No vehicles on file: plates could not be resolved.",
  "import_targa_non_trovata": "plate not found in the vehicle list",
  "import_data_non_valida": "invalid date",
  "import_quantita_non_valida": "invalid quantity",
  "import_importo_non_valido": "invalid amount",
  "sincronizza_dkv": "Sync DKV",
  "sync_dkv_esito": "DKV: {{created}} new, {{skipped}} already present, {{unmatched}} without a vehicle",
  "sync_dkv_errore": "DKV sync failed",
  "costi": "Costs",
  "nessun_costo": "No costs recorded",
  "nessun_costo_hint": "Costs come from refuelings, maintenance records and damages with an amount.",
  "costo_riparazione": "Repair cost (€)",
  "carburante": "Fuel",
  "costo_km_non_calcolabile": "At least two odometer readings are needed",
  "costo_km_su_mezzi": "Over {{count}} vehicles · {{km}} km travelled",
  "km_percorsi_letture": "{{km}} km over {{count}} readings",
  "nota_costi": "What it includes",
  "nota_costi_testo": "Running cost: fuel, maintenance and damages with an amount. It does not include depreciation, residual value or rental contract fees.",
  "km_inferiori_conferma": "The vehicle is at {{current}} km and you are recording {{value}} km. Save anyway?",
  "km_salto_conferma": "Jump of {{jump}} km from the last {{current}} recorded. Save anyway?",
  "tipo_contratto": "Contract type",
  "contratto_specifica": "Specify the contract",
  "contratto_non_registrato": "Not recorded",
  "contratto_in_corso": "Current contract",
  "storico_contrattuale": "Contract history",
  "nuovo_contratto": "New contract",
  "modifica_contratto": "Edit contract",
  "nessun_contratto_registrato": "No contract recorded",
  "nessun_contratto_in_corso": "No current contract",
  "nessun_contratto_in_corso_desc": "Record the applied contract with its effective date.",
  "sicuro_rimuovi_contratto": "Delete this entry from the contract history? For a change, add a new contract instead of deleting.",
  "contract_type_ccnl_commercio": "CCNL Commercio",
  "contract_type_ccnl_autorimesse_ncc": "CCNL Autorimesse / NCC",
  "contract_type_partita_iva": "Self-employed (VAT)",
  "contract_type_altro": "Other",
  "contract_state_current": "Current",
  "contract_state_future": "Future",
  "contract_state_ended": "Ended",
  "data_decorrenza": "Effective date",
  "data_fine_eventuale": "End date (if any)",
  "tempo_indeterminato": "Open-ended",
  "livello_qualifica": "Level / grade",
  "ore_settimanali": "Weekly hours",
  "contratto_indeterminato_hint": "Without an end date the contract is treated as open-ended.",
  "contratto_tipo_obbligatorio": "Contract type is required.",
  "contratto_altro_obbligatorio": "Specify the contract in the \"Other\" field.",
  "contratto_decorrenza_obbligatoria": "Effective date is required.",
  "contratto_date_incoerenti": "The end date precedes the effective date.",
  "limitazioni_autorizzazioni": "Limitations and authorizations",
  "limitazioni": "Limitations",
  "limitazioni_operative": "Operational limitations",
  "tipo_limitazione": "Limitation type",
  "descrizione_limitazione": "Description",
  "nuova_limitazione": "New operational limitation",
  "modifica_limitazione": "Edit limitation",
  "aggiungi_limitazione": "Add limitation",
  "nessuna_limitazione": "No limitations",
  "nessuna_limitazione_desc": "Limitations recorded here warn the dispatcher when a service requires an incompatible capability.",
  "sicuro_rimuovi_limitazione": "Delete this limitation from the history? For one that no longer applies, use \"Revoke\" instead of deleting.",
  "limitation_type_no_wheelchair_push": "Cannot push wheelchairs",
  "limitation_type_no_architectural_barriers": "Cannot handle services with architectural barriers",
  "limitation_type_no_lifting": "Cannot lift weights / bedridden passengers",
  "limitation_type_no_oxygen": "Not qualified to handle oxygen",
  "limitation_type_no_passenger_assistance": "Cannot assist the passenger",
  "limitation_type_altro": "Other",
  "limitation_state_active": "Active",
  "limitation_state_to_verify": "To verify",
  "limitation_state_scheduled": "Scheduled",
  "limitation_state_revoked": "Revoked",
  "limitazione_origine": "Source / reported by",
  "requisiti_bloccati": "Blocked capabilities",
  "nessun_impatto": "No operational impact",
  "impatto_pianificazione": "Impact on planning",
  "limitazione_blocca_hint": "Assigning a service that requires these capabilities will warn the dispatcher.",
  "limitazione_senza_impatto_hint": "This type is not tied to a service capability: it stays on record as an operational note, with no warning at assignment time.",
  "limitazione_indeterminata_hint": "Without an end date the limitation is open-ended.",
  "limitazione_scadenza_hint": "On the end date the limitation is not deleted: it moves to \"To verify\" and requires a confirmation or a revocation.",
  "limitazione_tipo_obbligatorio": "Limitation type is required.",
  "limitazione_descrizione_obbligatoria": "Describe the limitation.",
  "limitazione_inizio_obbligatorio": "Start date is required.",
  "limitazione_date_incoerenti": "The end date precedes the start date.",
  "limitazioni_da_verificare_n": "{{count}} to verify",
  "limitazioni_tutte": "Limitations: all",
  "limitazioni_con": "With limitations",
  "limitazioni_da_verificare": "Limitations to verify",
  "limitazioni_senza": "Without limitations",
  "conferma_proroga": "Confirm / extend",
  "conferma_proroga_limitazione": "Confirm or extend",
  "revoca": "Revoke",
  "revoca_limitazione": "Revoke limitation",
  "nuova_data_fine": "New end date",
  "motivo_revoca": "Reason for revocation",
  "note_verifica": "Verification notes",
  "verificata_il": "Verified on",
  "revocata_il": "Revoked on",
  "proroga_senza_data_hint": "Without a new end date the limitation becomes open-ended.",
  "deadline_cat_driver_limitation": "Driver limitation",
  "driver_limitation": "Driver operational limitation",
  "assegnazioni_incompatibili": "Incompatible assignments",
  "nessuna_incompatibilita": "No incompatibility",
  "capability_push_wheelchair": "Wheelchair pushing",
  "capability_architectural_barriers": "Architectural barriers",
  "capability_stretcher_lifting": "Lifting bedridden passengers",
  "capability_oxygen_handling": "Oxygen handling",
  "capability_passenger_assistance": "Passenger assistance",
  "capability_conflict_message": "Incompatible operational limitation: {{summary}}",
  "autorizzazioni": "Authorizations",
  "nuova_autorizzazione": "New authorization",
  "modifica_autorizzazione": "Edit authorization",
  "aggiungi_autorizzazione": "Add authorization",
  "nessuna_autorizzazione": "No authorization recorded",
  "nessuna_autorizzazione_desc": "Until there is a record with the signed document, the release shows as \"Missing document\".",
  "sicuro_rimuovi_autorizzazione": "Delete this authorization from the history? For a revocation, set the status to \"Revoked\" instead of deleting.",
  "policy": "Policy",
  "policy_image_release": "Image release",
  "liberatoria_immagini": "Image release",
  "liberatoria_tutte": "Image release: all",
  "authorization_state_authorized": "Authorized",
  "authorization_state_not_authorized": "Not authorized",
  "authorization_state_revoked": "Revoked",
  "authorization_state_missing_document": "Missing document",
  "finalita_autorizzate": "Authorized purposes",
  "purpose_internal": "Internal use",
  "purpose_website": "Website",
  "purpose_social": "Social networks",
  "purpose_press": "Press and releases",
  "purpose_recruiting": "Recruiting",
  "purpose_commercial": "Commercial material",
  "data_sottoscrizione": "Signature date",
  "data_revoca": "Revocation date",
  "documento_firmato": "Signed document",
  "carica_documento": "Upload document",
  "sostituisci_documento": "Replace document",
  "scollega": "Unlink",
  "non_allegato": "Not attached",
  "documento_richiesto_hint": "Without the signed document the authorization stays in \"Missing document\".",
  "documento_facoltativo_hint": "Document optional.",
  "upload_gestore_mancante": "Cannot upload: driver has no associated manager.",
  "caricamento_riuscito": "Document uploaded",
  "policy_obbligatoria": "Policy is required.",
  "data_sottoscrizione_obbligatoria": "Signature date is required for an authorization.",
  "data_revoca_obbligatoria": "Revocation date is required.",
  "revoca_prima_sottoscrizione": "The revocation precedes the signature.",
  "finalita_obbligatorie": "Indicate at least one authorized purpose.",
  "cancellation_reason_customer_request": "Cancellation requested by the customer/user",
  "cancellation_reason_appointment_cancelled": "Appointment or visit cancelled/postponed",
  "cancellation_reason_health_status_changed": "Admission, discharge or changed health condition",
  "cancellation_reason_other_transport": "Transport arranged by other means",
  "cancellation_reason_booking_error": "Booking error / duplicate service",
  "cancellation_reason_service_rebooked": "Service changed with a new booking",
  "cancellation_reason_user_not_transportable": "User not transportable / requirements not compatible",
  "cancellation_reason_no_show": "No-show / user not present",
  "cancellation_reason_mbility_unavailable": "Cancelled due to Mbility unavailability",
  "cancellation_reason_vehicle_unavailable": "Technical issue / vehicle unavailable",
  "cancellation_reason_force_majeure": "Force majeure / external cause",
  "cancellation_reason_other": "Other",
  "causale_annullamento": "Cancellation reason",
  "seleziona_causale": "Select a reason…",
  "nota": "Note",
  "nota_obbligatoria": "Note required for \"Other\"",
  "nota_facoltativa": "Note (optional)",
  "annulla_viaggio": "Cancel trip",
  "annulla_n_viaggi": "Cancel {{count}} trips",
  "adv_channel_google": "Google",
  "adv_channel_facebook": "Facebook",
  "adv_channel_instagram": "Instagram",
  "adv_channel_email": "Email",
  "adv_channel_flyer": "Flyer",
  "adv_channel_qr_code": "QR code",
  "adv_channel_word_of_mouth": "Word of mouth",
  "adv_channel_healthcare_facility": "Care home/Hospital",
  "adv_channel_billboard": "Billboards",
  "adv_channel_brevo_chatbot": "Brevo chatbot",
  "adv_channel_existing_customer": "Existing customer",
  "adv_channel": "Acquisition channel",
  "seleziona_canale": "Select a channel…",
  "canale_provenienza": "Acquisition channel",
  "nascondi_non_specificato": "Hide unspecified",
  "non_specificato": "Unspecified",
  "linea_business": "Business line",
  "seleziona_linea_business": "No line assigned",
  "prezzo_al_km": "Price per km (€)",
  "validita": "Validity",
  "valido_dal": "Valid from",
  "valido_al": "Valid to",
  "sempre_valido": "Always valid",
  "fine_prima_inizio": "The end date precedes the start date",
  "periodo_validita_non_valido": "The validity period is not valid: check the dates.",
  "tipo_servizio": "Service type",
  "validi_e_futuri": "Current and upcoming",
  "validi_oggi": "Valid today",
  "programmati": "Scheduled",
  "scaduti": "Expired",
  "archiviati": "Archived",
  "in_servizio": "In service",
  "programmato": "Scheduled",
  "archiviato": "Archived",
  "nessun_pianificato_per_filtro": "No planned trip for this filter",
  "di_n_totali": "of {{total}} total",
  "analytics_autisti": "Driver analytics",
  "occupazione_autisti_sottotitolo": "Occupancy, capacity and delays by day and time slot",
  "occupazione": "Occupancy",
  "imposta_i_filtri": "Set the filters",
  "avvia_analisi_occupazione": "Choose period, managers and job codes, then press Apply to compute occupancy.",
  "errore_di_caricamento": "Loading error",
  "errore_caricamento_occupazione": "Could not load occupancy. Please retry.",
  "saturazione_media": "Average saturation",
  "nessun_turno_nel_periodo": "No shift in this period",
  "tempo_occupato": "Busy time",
  "capacita": "Capacity",
  "tempo_tra_servizi": "Time between services",
  "sovrapposizioni": "Overlaps",
  "nota_tempo_a_vuoto": "Deadhead time is not recorded as its own value: it is measured as “time between services”, which also includes unrecorded waits and breaks.",
  "nota_pooling_stimato": "pooled rides have no recorded route: duration is estimated from pickup times.",
  "nota_tempi_reali": "Too many orders in this period to reconstruct every real time: the punctuality shown is partial.",
  "nota_annullati": "Too many cancellations in this period to date them all: only those recorded with the dedicated status are included.",
  "riepilogo_mensile": "Monthly summary",
  "avvia_riepilogo_autisti": "Choose period and managers, then press Apply.",
  "performance": "Performance",
  "avvia_confronto_performance": "Choose period and managers, then press Apply to compare scores.",
  "errore_caricamento_performance": "Could not compute the scores. Please retry.",
  "performance_nota_copertura": "A “—” means insufficient data for that component, not poor performance: components without coverage are excluded from the calculation and their weight is redistributed.",
  "giri_in_pooling": "Pooling",
  "tempo_di_ritorno": "Return",
  "trasferimento_a_vuoto": "Deadhead",
  "nessun_mezzo_assegnato": "No vehicle assigned that day.",
  "mezzo_senza_gps": "The assigned vehicle has no GPS identifier.",
  "nessun_punto_gps": "No position recorded in this hour.",
  "errore_tracciato": "Could not load the track.",
  "sovrapposizione": "Overlap",
  "tratte": "legs",
  "in_partenza": "departing",
  "in_arrivo": "arriving",
  "durata_stimata": "estimated duration",
  "vedi_tracciato": "View track",
  "tracciato_del_mezzo": "Track of the assigned vehicle: the driver-vehicle pairing can change during the day.",
  "dettaglio_cella": "Cell detail",
  "errore_dettaglio_cella": "Could not load the detail.",
  "nessuna_attivita": "No activity",
  "nessun_autista_in_questa_ora": "No driver is busy or on shift in this hour.",
  "tutte_le_commesse": "All job codes",
  "selezionate": "selected",
  "nessuna_commessa": "No job code",
  "pause_come_capacita": "Breaks as capacity",
  "passa_sulla_cella_per_il_dettaglio": "Hover a cell for the summary, click for the driver detail",
  "nascondi_ore_vuote": "Hide empty hours",
  "viaggi_ricorrenti": "Recurring trips",
  "non_disponibile": "Not available",
  "permesso": "Leave",
  "minuti_capacita": "Capacity minutes",
  "autisti_occupati": "Busy drivers",
  "autisti_liberi": "Free drivers",
  "saturazione": "Saturation",
  "tempo_libero": "Free time",
  "composizione": "Composition",
  "trasferimenti_e_attese": "Transfers and waits",
  "doppia_prenotazione": "Double booking",
  "ritardi": "Delays",
  "ritardo_partenza": "Departure delay",
  "ritardo_arrivo": "Arrival delay",
  "puntualita": "Punctuality",
  "dati_insufficienti": "insufficient data",
  "per_assenza": "of which for absence",
  "capacita_sprecata": "Wasted capacity",
  "nel_tempo_tra_servizi": "within time between services",
  "non_misurato": "Not measured",
  "performance_index": "Performance Index",
  "valutazione": "Rating",
  "desc_saturazione": "Busy minutes over shift minutes, hour by hour. A grey cell is “no shift”, which is not the same as 0%. Red above 100%: work assigned beyond the shift.",
  "desc_tempo_occupato": "Minutes the driver is busy: service, vehicle stop, return, events and transfers. It is the union of commitments, so two overlapping rides do not add up to 120 minutes in one hour.",
  "desc_tempo_libero": "Residual capacity: shift minutes minus busy minutes. Negative values in red: overload, i.e. more work assigned than the shift can hold.",
  "saturazione_autisti": "Driver saturation",
  "desc_saturazione_autisti": "Drivers busy over those on shift, counted by head: answers “how many vehicles do I still have free”, not “how much time do I have left”. A driver busy for 5 minutes counts here the same as one busy for 60. Red above 100%.",
  "desc_autisti_liberi": "Drivers on shift with no commitment in that hour. Negative values in red: more drivers are working than appear on shift, i.e. missing shifts or rides assigned off-shift.",
  "desc_autisti_occupati": "Drivers with at least one commitment touching that hour: one minute is enough to count.",
  "desc_autisti_in_turno": "Drivers with an active capacity shift (available, extra, stationed). Vacation, sick leave and time off do not count: a driver on vacation is not unused capacity.",
  "desc_tempo_tra_servizi": "Gaps between one service and the next for the same driver, within the shift. They include deadhead transfer, but also unrecorded waits and breaks: it is an upper bound, not driving time.",
  "desc_sovrapposizioni": "Minutes assigned twice to the same driver: double booking. Any cell with a value is in red — there is no acceptable threshold. Measured on planned times, so it shows before the day is even worked.",
  "desc_ritardi": "Sum of departure delays, positive only (early departures do not offset), attributed to the planned departure hour. Requires a recorded real time: where there is none, the cell stays empty.",
  "desc_annullati_24h": "Rides cancelled with less than 24 hours' notice, counted in the hour they would have run. They do not occupy the driver: they are wasted capacity.",
  "scala_soglie_fisse": "Color on fixed thresholds: 25 / 50 / 75 / 100%. Comparable across different months and managers.",
  "scala_relativa": "Color relative to this grid's maximum value: shows where the phenomenon concentrates this month, not its value against another month.",
  "senza_autista": "No driver assigned",
  "drivers": "Drivers",
  "foto_evento": "Event photo",
  "nessuna_foto": "No photos attached",
  "anteprima_foto": "Photo preview",
  "chiudi_anteprima": "Close preview",
  "foto_precedente": "Previous photo",
  "foto_successiva": "Next photo",
  "caricamento_foto": "Loading photos…",
  "foto_non_disponibile": "Photo unavailable",
  "op2_luogo_partenza": "Place (second operator at pickup)",
  "op2_luogo_arrivo": "Place (second operator at drop-off)",
  "tipologia_carrozzina": "Wheelchair type",
  "copia_viaggio": "Copy trip",
  "utenze": "Accounts",
  "nuova_utenza": "New account",
  "modifica_utenza": "Edit account",
  "elimina_utenza": "Delete account",
  "disattiva_utenza": "Disable account",
  "riattiva_utenza": "Enable account",
  "nessuna_utenza": "No accounts",
  "nessuna_utenza_msg": "Create an account to give access to the company portal.",
  "utenza_attiva": "Active account (can sign in)",
  "nuova_password_opzionale": "New password (leave empty to keep it)",
  "ruolo_account_b2b": "Company portal",
  "ruolo_account_cdi": "Day center",
  "sicuro_elimina_utenza": "The account will lose access to the portal and be permanently deleted. To suspend it only, use Disable. Continue?",
  "tipo_check": "Check type",
  "check_inizio_giornata": "Start of day",
  "check_durante_giornata": "During the day",
  "check_da_menu": "Daily check",
  "livello_carburante": "Fuel level",
  "pulizia_mezzo": "Vehicle cleanliness",
  "carburante_pieno": "Full",
  "carburante_tre_quarti": "3/4",
  "carburante_meta": "1/2",
  "carburante_un_quarto": "1/4",
  "carburante_riserva": "Reserve",
  "pulizia_buona": "Good",
  "pulizia_sufficiente": "Sufficient",
  "pulizia_insufficiente": "Insufficient",
  "controlli_mezzo": "Vehicle checks",
  "controllo_spie": "Dashboard warning lights",
  "controllo_pneumatici": "Tyres",
  "controllo_luci": "Lights",
  "controllo_pedana": "Ramp / lift",
  "controllo_ancoraggi": "Wheelchair anchors",
  "controllo_cinture": "Passenger seat belts",
  "dotazione_gradino": "Step",
  "dotazione_carrozzina": "On-board wheelchair",
  "dotazione_estintore": "Fire extinguisher",
  "dotazione_pocket_mask": "Pocket mask",
  "dotazione_pos": "POS present and working",
  "dotazione_divisa": "Uniform worn",
  "anomalia_segnalata": "Issue reported",
  "nessuna_anomalia": "No issue",
  "note_check": "Driver notes",
  "voci_non_conformi": "Items not in order",
  "check_senza_controlli": "Filed from the app menu: no checklist",
  "esito_check": "Outcome",
  "cerca_indirizzo": "Search address",
  "cerca_indirizzo_placeholder": "Street, number, city",
  "filtra_viaggi": "Passenger or address",
  "mostra_tutti": "Show all",
  "mezzi_live_one": "{{count}} live vehicle",
  "mezzi_live_other": "{{count}} live vehicles",
  "aggiornato_alle": "updated at {{time}}",
  "velocita": "Speed",
  "corsa": "Ride",
  "giro": "Ride group",
  "senza_posizione": "no position",
  "rientro": "Way back",
  "wait_time_manual": "time entered by the driver",
  "fermo_auto_orario_manuale": "The wait time was entered by the driver, not measured by the app.",
  "tooltip_wait_open": "Waiting since {{from}} · {{planned}} min planned",
  "tooltip_wait_done": "Wait {{from}} → {{to}} · {{minutes}} min ({{planned}} planned)",
  "tooltip_passengers": "{{n}} passengers",
  "tooltip_wheelchairs": "{{n}} in wheelchair",
  "tooltip_absent": "{{n}} absent",
  "tooltip_group_progress": "On board {{onBoard}} · carried {{done}}/{{total}}",
  "tooltip_others": "+{{n}} more",
  "mancano_minuti": "{{count}} min left",
  "oltre_minuti": "{{count}} min over",
  "viaggi_annullati": "Cancelled trips",
  "viaggi_annullati_riepilogo": "{{trips}} cancelled trips · {{users}} users · {{withDriver}} with a driver",
  "viaggi_annullati_n_one": "{{count}} cancelled trip",
  "viaggi_annullati_n_other": "{{count}} cancelled trips",
  "nessun_viaggio_annullato": "No cancelled trip in this period",
  "cerca_utente_indirizzo": "Search user or address…",
  "solo_con_autista": "Only with an assigned driver",
  "senza_utente": "No user",
  "utente": "User",
  "annullato_il": "Cancelled on",
  "non_assegnato": "Unassigned",
  "con_autista_n_one": "{{count}} with a driver",
  "con_autista_n_other": "{{count}} with a driver",
  "ripristina": "Restore",
  "ripristina_viaggi": "Restore trips",
  "ripristina_viaggio": "Restore this trip",
  "ripristina_tutti_n_one": "Restore the trip",
  "ripristina_tutti_n_other": "Restore all {{count}} trips",
  "ripristina_conferma_uno": "The trip of {{name}} on {{when}} goes back in service.",
  "ripristina_conferma_molti_one": "One trip goes back in service.",
  "ripristina_conferma_molti_other": "{{count}} trips go back in service.",
  "ripristina_stato_recap": "{{assigned}} go back to Assigned (they still have a driver), {{inserted}} go back to Inserted.",
  "autista_gia_assegnato": "Driver still assigned",
  "ripristina_avviso_autista": "These trips go straight back to Assigned: check the driver is still available on that slot.",
  "ripristina_causale_rimossa": "The cancellation reason is removed from the trip; the status change stays in its history.",
  "viaggi_ripristinati_n_one": "Trip restored",
  "viaggi_ripristinati_n_other": "{{count}} trips restored",
  "ripristino_fallito": "Restore failed",
  "ripristina_esclusi_passati_one": "One trip is left out: it is on a past day and cannot be restored.",
  "ripristina_esclusi_passati_other": "{{count}} trips are left out: they are on past days and cannot be restored.",
  "non_ripristinabile_passato": "Cannot be restored: the trip is on a past day",
  "nessun_viaggio_ripristinabile": "No trip to restore: only trips from today onwards can be restored",
  "raggruppa_per_utente": "Group by user",
  "espandi": "Expand",
  "comprimi": "Collapse",
  "ripristina_per_date": "Restore by date",
  "seleziona_periodo": "Select a period",
  "seleziona_tutto": "Select all",
  "deseleziona_tutto": "Deselect all",
  "senza_data": "No date",
  "date_selezionate_n": "{{dates}} dates selected · {{trips}} trips",
  "spunta_date_periodo": "Tick the dates in range",
  "orario_non_disponibile": "time unavailable"
}
